import React, { useEffect, useRef, useState } from "react";

import type { TableProps } from "antd/es/table";
import { EllipsisOutlined } from "@ant-design/icons";
import { Divider, Flex, Tour, Typography } from "antd";
import type { TourProps } from "antd";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import HideSourceIcon from "@mui/icons-material/HideSource";

import SettingsIcon from "@mui/icons-material/Settings";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import type { ColumnType, ColumnsType } from "antd/es/table";
import { Col, Row, DatePicker } from "antd";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HelpIcon from "@mui/icons-material/Help";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import dayjs from "dayjs";
import StarsIcon from "@mui/icons-material/Stars";
import type { Dayjs } from "dayjs";
import { Skeleton } from "antd";
import { Dropdown, Form, Modal, message } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Highlighter from "react-highlight-words";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { AppstoreOutlined, SearchOutlined } from "@ant-design/icons";
import type { InputRef } from "antd";
import type { FilterConfirmProps, FilterValue } from "antd/es/table/interface";
import type { MenuProps } from "antd";

import TextArea from "antd/es/input/TextArea";
import { Button, Input, Space, Table } from "antd";
import { useQueryParams, StringParam, NumberParam } from "use-query-params";
import Globais, {
  CalcularDiferencaDias,
  validateDataPeriodo,
  validateToken,
  adicionarDiasData,
  validatePeriodoFracionado,
  formatarData,
  AlterarFormatoData,
  exibirMoeda,
  acertoPeriodosProprietario,
  validateDataCheckOutMaior,
  atualizarPeriodoUsuario,
  retornarValorAtualizado,
  retornaDiaDaSemana,
  formatarMoeda,
  tratamentoValoresInput,
  enviarEmail,
  verificarSituacaoFracionados,
  qualSituacao,
  deletarPeriodoUsuario,
  verificarSeTemPeriodoDivulgado,
  qualStatusAtualPeriodoUsuario,
  verSeTemFracoes,
} from "../../components/Globais";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { gridRowCountSelector } from "@mui/x-data-grid";
import Title from "antd/es/skeleton/Title";

import { Alert } from "antd";
import { useMediaQuery } from "react-responsive";
import {
  BotoesAcoes,
  Container,
  ContainerAdicionarPeriodo,
  ContainerFra,
  ContainerItems,
  ContainerLista,
  ContainerSeta,
  Icon,
  Items,
  ItemsFra,
} from "./styles";
import { Button as BtnMobile, Dropdown as DropdownMobile } from "antd-mobile";
import ModalAcoes from "./components/ModalAcoes";
import { formatValorReal } from "../../uteis/formatValorReal";
import { FiltroMobileModal } from "./components/ModalFiltroMobile";
import SituacaoInfoModal from "./components/SituacaoInfoModal";
import ModalReserva from "./components/ModalReserva";

const defaultPeriodoData = {
  cotaId: 0,
  checkIn: "",
  checkOut: "",
  dataEspecial: "",
  origem: 0,
};

interface DataType {
  especial: string;
  origem: any;
  periodoId: number;
  periodoUsuarioId: number;
  key: string;
  checkIn: string;
  checkOut: string;
  situacao: string;
  divulgado: string;
  valorMin: string;
  valorSugerido: string;
  valorSugeridoSistema: string;
  valorSugeridoInicial: string;
  status: string;

  statusAnterior: string;
  dataEspecial: string;
  fracionamento: number;
  created_at: string;
}
interface ValuesFracaoCompleta {
  checkInPrincipal: string;
  checkOutPrincipal: string;
  valorMinPrincipal: string;
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface ValuesFracaoCompletaAtualizar {
  checkInPrincipal: string;
  checkOutPrincipal: string;
  valorMinPrincipal: string;
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface Values {
  title: string;
  description: string;
  // modifier: string;
}
interface ValuesValor {
  valorMin: string;
  // title: string;
  // description: string;
  // description: string;
  // modifier: string;
}
interface ValuesFracao {
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}
interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsValor {
  open: boolean;
  onCreate: (valuesValor: ValuesValor) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracaoCompleta {
  open: boolean;
  onCreate: (valuesFracaoCompleta: ValuesFracaoCompleta) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracaoCompletaAtualizar {
  open: boolean;
  onCreate: (
    valuesFracaoCompletaAtualizar: ValuesFracaoCompletaAtualizar
  ) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracao {
  open: boolean;
  onCreate: (valuesFracao: ValuesFracao) => void;
  onCancel: () => void;
}

type DataIndex = keyof DataType;
type MenuItem = Required<MenuProps>["items"][number];

const defaultValuesValorModal = {
  valorMin: "",
};
const defaultValuesValorModalFracaoCompleta = {
  valorMinPrincipal: "",
  valorMin1: "",
  valorMin2: "",
};

export default function ViewDisponibilizacaoPeriodos() {
  const [disponibilizarPeriodo, setDisponibilizarPeriodo] = useState<any>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [titleFracaoCompleta, setTitleFracaoCompleta] = useState(false);
  const [openDiariaErrada, setOpenDiariaErrada] = useState(false);
  const valuesValorModal = useRef(defaultValuesValorModal);

  const alterandoValor = useRef(false);
  const valorDiariaPrincipal = useRef(0.0);
  const valorDiariaFracao1 = useRef(0.0);
  const valorDiariaFracao2 = useRef(0.0);
  const colorPrincipal = useRef("black");
  const color1fracao = useRef("black");
  const color2fracao = useRef("black");
  const diferenca1 = useRef(0);
  const diferenca2 = useRef(0);
  const { Title } = Typography;
  const valuesValorModalFracaoCompleta = useRef(
    defaultValuesValorModalFracaoCompleta
  );
  const [nCotaUsuarioId, setNCotaUsuarioId] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });

  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});

  const numeroApto = useRef("");

  const nomeEmpreend = useRef("");

  const { RangePicker } = DatePicker;
  const emLote = useRef(0);
  const formDataPrincipal = useRef({});
  const formData1 = useRef({});
  const formData2 = useRef({});
  const periodoUsuario1Fracao = useRef(0);
  const periodoUsuario2Fracao = useRef(0);

  const situacao = useRef("");
  const excluindoFracionados = useRef(false);
  const situacaoAnterior = useRef("");
  const valor = useRef("");
  const valorSugeridoInicial = useRef("");
  const statusAtual = useRef("");
  const statusAnterior = useRef("");
  const periodo = useRef(0);
  const atualizando = useRef(false);
  const fracionando = useRef(false);
  const [messageApi, contextHolder] = message.useMessage();
  const periodoUsuario = useRef(0);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [openDelegar, setOpenDelegar] = useState(false);
  const [openAlterandoDivulgado, setOpenAlterandoDivulgado] = useState(false);
  const [openRetirarDelegar, setOpenRetirarDelegar] = useState(false);
  const [openNaoPertube, setOpenNaoPertube] = useState(false);
  const [openRetirarNaoPertube, setOpenRetirarNaoPertube] = useState(false);
  const [openExcluirFracionados, setOpenExcluirFracionados] = useState(false);
  const reservandoOuUtilizandoOuTrocando = useRef("");
  // const [cotaId, setCotaId] = useQueryParams({ cotaId: NumberParam });
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const alugarOuTrocar = useRef(0);
  const valorSugerido = useRef("");
  const valorSugeridoSistema = useRef("");

  const valorSugeridoSistema1Fracao = useRef("");
  const valorSugeridoSistema2Fracao = useRef("");
  const valorPrimeiroPeriodo = useRef("");
  const valorSegundoPeriodo = useRef("");
  const [open, setOpen] = useState(false);
  const divulgado = useRef("");
  const [openValor, setOpenValor] = useState(false);
  const searchInput = useRef<InputRef>(null);
  const [nCotaNumero, setCotaNumero] = useQueryParams({ ncota: NumberParam });
  const [isLoading, setIsLoading] = useState(true);
  const [nEmpreend, setNEmpreend] = useQueryParams({ empreend: StringParam });
  const [periodoData, setPeriodoData] = useState(defaultPeriodoData);
  const [status, setStatus] = useState<number>(0);
  const [openFracao, setOpenFracao] = useState(false);
  const fracionamento = useRef(0);
  const [texto, setTexto] = useState<string>("");
  const [openError, setOpenError] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [sugestaoCheckOut, setSugestaoCheckOut] = useState("");
  const checkInPeriodo = useRef("");
  const checkOutPeriodo = useRef("");
  const dateFormat = "DD/MM/YYYY";
  const checkInPrimeiroPeriodo = useRef("");
  const checkOutPrimeiroPeriodo = useRef("");
  const checkInSegundoPeriodo = useRef("");
  const checkOutSegundoPeriodo = useRef("");
  const checkInPeriodoAdicionado = useRef("");
  const checkOutPeriodoAdicionado = useRef("");
  const [openModalPerguntaFracaoCompleta, setOpenModalPerguntaFracaoCompleta] =
    useState(false);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const [periodoSelecionado, setPeriodoSelecionado] = useState<any | null>(null);
  
  const [modalFracionadosAberta, setModalFracionadosAberta] = useState(false);
  const [fracionadosAtuais, setFracionadosAtuais] = useState<any[]>([]);    

  const isAdmin = validateToken()?.nda;

  const [openTour, setOpenTour] = useState<boolean>(true);

  const [openModalFracaoCompleta, setOpenModalFracaoCompleta] = useState(false);
  const [
    openModalFracaoCompletaAtualizar,
    setOpenModalFracaoCompletaAtualizar,
  ] = useState(false);
  const [openFracaoCompleta, setOpenFracaoCompleta] = useState(false);

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const errorLongaDuracao = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
      duration: 8,
    });
  };
  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const successLongaDuracao = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
      duration: 8,
    });
  };

  //abre a modal de fracionados

 const abrirModalFracionados = (row: any) => {
  setPeriodoSelecionado(row);
  setModalFracionadosAberta(true);
};



  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      onSubmitAtualizarValorAluguel(valuesValorModal.current);
    }
  };
  const handleKeyPressFracaoCompleta = (e: any) => {
    if (e.key === "Enter") {
      if (
        valuesValorModalFracaoCompleta.current.valorMinPrincipal === "" ||
        valuesValorModalFracaoCompleta.current.valorMin1 === "" ||
        valuesValorModalFracaoCompleta.current.valorMin2 === ""
      ) {
        error("Preencha todos os valores");
      } else {
        onSubmitAtualizarValorAluguelFracaoCompleta(
          valuesValorModalFracaoCompleta.current
        );
      }
    }
  };
  //React.FormEvent<HTMLFormElement>
  const onChangeFormValor = (valuesValor: any) => {
    valuesValorModal.current = {
      valorMin: valuesValor.target.value.replace(" ", ""),
    };
  };
  const onChangeFormFracaoCompleta = (valuesFracaoCompleta: any) => {
    if (valuesFracaoCompleta.target.id === "valorMinPrincipal") {
      valuesValorModalFracaoCompleta.current = {
        valorMinPrincipal: valuesFracaoCompleta.target.value,
        valorMin1: valuesValorModalFracaoCompleta.current.valorMin1,
        valorMin2: valuesValorModalFracaoCompleta.current.valorMin2,
      };
    } else {
      if (valuesFracaoCompleta.target.id === "valorMin1") {
        valuesValorModalFracaoCompleta.current = {
          valorMinPrincipal:
            valuesValorModalFracaoCompleta.current.valorMinPrincipal,
          valorMin1: valuesFracaoCompleta.target.value,
          valorMin2: valuesValorModalFracaoCompleta.current.valorMin2,
        };
      } else {
        if (valuesFracaoCompleta.target.id === "valorMin2") {
          valuesValorModalFracaoCompleta.current = {
            valorMinPrincipal:
              valuesValorModalFracaoCompleta.current.valorMinPrincipal,
            valorMin1: valuesValorModalFracaoCompleta.current.valorMin1,
            valorMin2: valuesFracaoCompleta.target.value,
          };
        }
      }
    }
  };

  const CollectionCreateFormValor: React.FC<CollectionCreateFormPropsValor> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openValor}
        title="Incluir valor do aluguel"
        okText="Incluir"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((valuesValor) => {
              form.resetFields();
              onCreate(valuesValor);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          initialValues={{ modifier: "public" }}
          onKeyUp={handleKeyPress}
          onChange={(valuesValor) => {
            onChangeFormValor(valuesValor);
          }}
        >
          <Row>
            <Col span={16}>
              <Form.Item
                name="valorMin"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
            <Col
              span={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>

          {/* <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item> */}
        </Form>
      </Modal>
    );
  };

  const onRangeChangePrimeiroPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          dateStrings[0],
          dateStrings[1],
          "",
          ""
        ) === "ok"
      ) {
        checkInPrimeiroPeriodo.current = dateStrings[0];
        checkOutPrimeiroPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[1]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            dateStrings[0],
            dateStrings[1],
            "",
            ""
          )
        );
      }
    }
  };

  const onRangeChangeSegundoPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          "",
          "",
          dateStrings[0],
          dateStrings[1]
        )
      ) {
        checkInSegundoPeriodo.current = dateStrings[0];
        checkOutSegundoPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[0]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            "",
            "",
            dateStrings[0],
            dateStrings[1]
          )
        );
      }
    }
  };
  const AbriModalFracaoCompleta = () => {
    setOpenModalPerguntaFracaoCompleta(false);

    if (atualizando.current) {
      setOpenModalFracaoCompletaAtualizar(true);
    } else {
      setOpenModalFracaoCompleta(true);
    }
  };
  const FecharPerguntaFracaoCompleta = () => {
    setOpenModalPerguntaFracaoCompleta(false);
  };

  const atualizarValorAluguel = async (
    periodoUsuarioId: any,
    tipo: number,
    atualizandoFracao: boolean
  ) => {
    setOpenModalFracaoCompleta(false);
    setOpenModalFracaoCompletaAtualizar(false);

    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuario.current);

    const Token = validateToken();

    const valorMin = valor.current;
    let formData = {};
    let periodoUsuario1Fracao = 0;
    let periodoUsuario2Fracao = 0;
    // let valorPrincipal = 0;
    // let valor1Fracao = 0;
    // let valor2Fracao = 0;

    let situacaoAnterior1;
    let situacaoAnterior2;
    let situacaoAnteriorPrincipal;
    let temFracoes = false;

    switch (situacao.current) {
      case "Alugar":
        situacaoAnterior.current = "ALUGAR";
        break;
      case "Alugar ou trocar":
        situacaoAnterior.current = "ALUGAR_TROCAR";

        break;
      case "Trocar":
        situacaoAnterior.current = "TROCAR";
        break;
      case "Não definido":
        situacaoAnterior.current = "SEM_STATUS";
        break;
      case "Reservado pelo próprio":
        situacaoAnterior.current = "CONCLUIDO_PELO_PROPRIO";
        break;
      case "Será utilizado":
        situacaoAnterior.current = "UTILIZADO";
        break;
    }

    if (statusAtual.current === "VALOR_ALTO") {
      statusAtual.current = "SEM_STATUS";
    }

    if (tipo === 1) {
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

        if (statusAtual.current === "DELEGADO") {
          if (!(await divulgando)) {
            formData = {
              alugar: 1,
              trocar: 0,
              concluido: 0,
              utilizar: 0,
              valorMin: formatarMoeda(valorMin),
              alterado: 1,
              status: "DELEGADO",
              statusAnterior: statusAtual.current,
            };
          } else {
            if (await divulgando) {
              formData = {
                alugar: 1,
                trocar: 0,
                concluido: 0,
                utilizar: 0,
                valorSugerido: formatarMoeda(valorMin),
                statusAnterior: "DELEGADO",
                status: "ALTERANDO",
              };
            }
          }
        } else {
          if (statusAtual.current === "NAO_PERTUBE") {
            if (!(await divulgando)) {
              formData = {
                alugar: 1,
                trocar: 0,
                concluido: 0,
                utilizar: 0,
                alterado: 1,
                valorMin: formatarMoeda(valorMin),
                status: "NAO_PERTUBE",
                statusAnterior: statusAtual.current,
              };
            } else {
              if (await divulgando) {
                formData = {
                  alugar: 1,
                  trocar: 0,
                  concluido: 0,
                  utilizar: 0,
                  valorSugerido: formatarMoeda(valorMin),
                  statusAnterior: "NAO_PERTUBE",
                  status: "ALTERANDO",
                };
              }
            }
          } else {
            if (!(await divulgando)) {
              formData = {
                alugar: 1,
                trocar: 0,
                concluido: 0,
                utilizar: 0,
                alterado: 1,
                valorMin: formatarMoeda(valorMin),
                status:
                  statusAtual.current === "FINALIZADO"
                    ? "SEM_STATUS"
                    : statusAtual.current,
              };
            } else {
              if (await divulgando) {
                formData = {
                  alugar: 1,
                  trocar: 0,
                  concluido: 0,
                  utilizar: 0,
                  situacaoAnterior: situacaoAnterior.current,
                  valorSugerido: formatarMoeda(valorMin),
                  statusAnterior: statusAtual.current,
                  status: "ALTERANDO",
                };
                disponibilizarPeriodo.map((p: any) => {
                  if (p.id === periodoUsuario.current) {
                    if (p.children) {
                      temFracoes = true;

                      //aqui

                      p.children.filter(async (q: any) => {
                        if (q.fracionamento === p.id) {
                          if (periodoUsuario1Fracao === 0) {
                            periodoUsuario1Fracao = q.id;
                            situacaoAnterior1 = qualSituacao(
                              0,
                              0,
                              0,
                              0,
                              2,
                              q.situacao
                            );
                            formData1.current = {
                              status: "ALTERANDO",

                              periodoUsuario: q.id,
                              situacaoAnterior: situacaoAnterior1,
                              caso: 2,
                              statusAnterior:
                                await qualStatusAtualPeriodoUsuario(q.id),
                            };
                          } else {
                            periodoUsuario2Fracao = q.id;
                            situacaoAnterior2 = qualSituacao(
                              0,
                              0,
                              0,
                              0,
                              2,
                              q.situacao
                            );
                            formData2.current = {
                              status: "ALTERANDO",
                              periodoUsuario: q.id,
                              situacaoAnterior: situacaoAnterior2,
                              caso: 2,
                              statusAnterior:
                                await qualStatusAtualPeriodoUsuario(q.id),
                            };
                          }
                        }
                      });
                    }
                  } else {
                    if (p.children) {
                      temFracoes = true;
                      p.children.filter(async (q: any) => {
                        if (q.id === periodoUsuario.current) {
                          temFracoes = true;
                          periodoUsuario1Fracao = q.id;
                          situacaoAnterior1 = qualSituacao(
                            0,
                            0,
                            0,
                            0,
                            2,
                            q.situacao
                          );

                          formData1.current = {
                            status: "ALTERANDO",
                            periodoUsuario: q.id,
                            situacaoAnterior: situacaoAnterior1,
                            alugar: 1,
                            trocar: 0,
                            utilizar: 0,
                            concluido: 0,
                            alterado: 0,
                            caso: 2,
                            statusAnterior: await qualStatusAtualPeriodoUsuario(
                              q.id
                            ),
                          };
                          situacaoAnteriorPrincipal = qualSituacao(
                            0,
                            0,
                            0,
                            0,
                            2,
                            q.situacao
                          );
                          formData = {
                            status: "ALTERANDO",
                            periodoUsuario: q.fracionamento,
                            situacaoAnterior: situacaoAnteriorPrincipal,
                            caso: 2,
                            statusAnterior: await qualStatusAtualPeriodoUsuario(
                              q.fracionamento
                            ),
                          };
                          p.children.filter(async (z: any) => {
                            if (
                              z.fracionamento === q.fracionamento &&
                              q.id !== z.id
                            ) {
                              periodoUsuario2Fracao = q.id;
                              situacaoAnterior2 = qualSituacao(
                                0,
                                0,
                                0,
                                0,
                                2,
                                q.situacao
                              );
                              formData2.current = {
                                status: "ALTERANDO",
                                periodoUsuario: z.id,
                                situacaoAnterior: situacaoAnterior2,
                                caso: 2,
                                statusAnterior:
                                  await qualStatusAtualPeriodoUsuario(z.id),
                              };
                            }
                          });
                        }
                      });
                    }
                  }
                });
              }
            }
          }
        }

        return disponibilizarPeriodo.filter(async (p: any) => {
          if ((await p.id) === periodoUsuario.current) {
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                let resultEmail;
                if (await divulgando) {
                  if (temFracoes) {
                    const result1 = atualizarPeriodoUsuario(formData1.current);
                    if (await result1) {
                      const result2 = atualizarPeriodoUsuario(
                        formData2.current
                      );
                      if (await result2) {
                        return 1;
                      }
                    }
                  } else {
                    success("Período atualizado com sucesso!");
                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  }
                } else {
                  let formDataEmail = {
                    tipoEmail: 16,

                    periodoUsuarioId: periodoUsuario.current,
                    situacao: "Alugar",
                    valorMin: valor.current,
                  };

                  if ((await divulgando) || fracionando) {
                    resultEmail = true;
                  } else {
                    resultEmail = enviarEmail(formDataEmail);
                  }

                  if (await resultEmail) {
                    if (atualizandoFracao) {
                      return 1;
                    } else {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                      return p;
                    }
                  } else {
                    error(
                      "Tivemos um problema no envio de e-mail de comprovação."
                    );
                    return p;
                  }
                }
              } else {
                error("Algo deu errado!");
                return null;
              }
            } catch (error) {
              error("Algo deu errado!");
              return null;
            }
          } else {
            if (p.children) {
              p.children.filter(async (q: any) => {
                if (q.id === periodoUsuario.current) {
                  const URLPrincipal = `${Globais.DOMINIOBACK}/periodo-usuario/${q.fracionamento}`;
                  let formDataPrincipal = {
                    status: "SEM_STATUS",
                  };
                  try {
                    const responseFilho = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (responseFilho) {
                      let responsePai;
                      if (
                        !(
                          statusAtual.current === "DELEGADO" ||
                          statusAtual.current === "NAO_PERTUBE"
                        )
                      ) {
                        responsePai = await axios.put(
                          URLPrincipal,
                          formDataPrincipal,
                          {
                            headers: { Authorization: Token.AuthStr },
                          }
                        );
                      } else {
                        responsePai = true;
                      }

                      if (responsePai) {
                        if (atualizandoFracao) {
                          return 1;
                        } else {
                          let formDataEmail = {
                            tipoEmail: 16,

                            periodoUsuarioId: periodoUsuario.current,
                            situacao: "Alugar",
                            valorMin: valor.current,
                          };

                          let resultEmail;
                          if (await divulgando) {
                            resultEmail = true;
                          } else {
                            resultEmail = enviarEmail(formDataEmail);
                          }

                          if (await resultEmail) {
                            success("Período atualizado com sucesso!");
                            setTimeout(() => {
                              document.location.reload();
                            }, 2000);
                            return 1;
                          } else {
                            error(
                              "Tivemos um problema no envio de e-mail de comprovação."
                            );
                            return 0;
                          }
                        }
                      } else {
                        error("Algo deu errado!");
                        return 0;
                      }
                    } else {
                      error("Algo deu errado!");
                      return 0;
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                    return 0;
                  }
                }
              });
            }
          }
        });
      } else {
        document.location.href = "/";
        return 0;
      }
    } else {
      if (tipo === 2) {
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
          if (statusAtual.current === "DELEGADO") {
            if (!(await divulgando)) {
              formData = {
                alugar: 1,
                trocar: 1,
                concluido: 0,
                utilizar: 0,
                alterado: 1,
                valorMin: formatarMoeda(valorMin),
                status: "DELEGADO",
                statusAnterior: statusAtual.current,
              };
            } else {
              if (await divulgando) {
                formData = {
                  alugar: 1,
                  trocar: 1,
                  concluido: 0,
                  utilizar: 0,
                  valorSugerido: formatarMoeda(valorMin),
                  statusAnterior: "DELEGADO",
                  status: "ALTERANDO",
                };
              }
            }
          } else {
            if (statusAtual.current === "NAO_PERTUBE") {
              if (!(await divulgando)) {
                formData = {
                  alugar: 1,
                  trocar: 1,
                  concluido: 0,
                  utilizar: 0,
                  alterado: 1,
                  valorMin: formatarMoeda(valorMin),
                  status: "NAO_PERTUBE",
                  statusAnterior: statusAtual.current,
                };
              } else {
                if (await divulgando) {
                  formData = {
                    alugar: 1,
                    trocar: 1,
                    concluido: 0,
                    utilizar: 0,
                    valorSugerido: formatarMoeda(valorMin),
                    statusAnterior: "NAO_PERTUBE",
                    status: "ALTERANDO",
                  };
                }
              }
            } else {
              if (!(await divulgando)) {
                formData = {
                  alugar: 1,
                  trocar: 1,
                  concluido: 0,
                  utilizar: 0,
                  alterado: 1,
                  valorMin: formatarMoeda(valorMin),
                  status:
                    statusAtual.current === "FINALIZADO"
                      ? "SEM_STATUS"
                      : statusAtual.current,
                };
              } else {
                if (await divulgando) {
                  formData = {
                    alugar: 1,
                    trocar: 1,
                    concluido: 0,
                    utilizar: 0,
                    situacaoAnterior: situacaoAnterior.current,
                    valorSugerido: formatarMoeda(valorMin),
                    statusAnterior: statusAtual.current,
                    status: "ALTERANDO",
                  };
                  disponibilizarPeriodo.map((p: any) => {
                    if (p.id === periodoUsuario.current) {
                      if (p.children) {
                        temFracoes = true;

                        p.children.filter(async (q: any) => {
                          if (q.fracionamento === p.id) {
                            if (periodoUsuario1Fracao === 0) {
                              periodoUsuario1Fracao = q.id;
                              situacaoAnterior1 = qualSituacao(
                                0,
                                0,
                                0,
                                0,
                                2,
                                q.situacao
                              );
                              formData1.current = {
                                status: "ALTERANDO",
                                periodoUsuario: q.id,
                                situacaoAnterior: situacaoAnterior1,
                                caso: 2,
                                statusAnterior:
                                  await qualStatusAtualPeriodoUsuario(q.id),
                              };
                            } else {
                              periodoUsuario2Fracao = q.id;
                              situacaoAnterior2 = qualSituacao(
                                0,
                                0,
                                0,
                                0,
                                2,
                                q.situacao
                              );
                              formData2.current = {
                                status: "ALTERANDO",
                                periodoUsuario: q.id,
                                situacaoAnterior: situacaoAnterior2,
                                caso: 2,
                                statusAnterior:
                                  await qualStatusAtualPeriodoUsuario(q.id),
                              };
                            }
                          }
                        });
                      }
                    } else {
                      if (p.children) {
                        p.children.filter(async (q: any) => {
                          if (q.id === periodoUsuario.current) {
                            temFracoes = true;
                            periodoUsuario1Fracao = q.id;
                            situacaoAnterior1 = qualSituacao(
                              0,
                              0,
                              0,
                              0,
                              2,
                              q.situacao
                            );

                            formData1.current = {
                              status: "ALTERANDO",
                              periodoUsuario: q.id,
                              situacaoAnterior: situacaoAnterior1,
                              alugar: 1,
                              trocar: 1,
                              utilizar: 0,
                              concluido: 0,
                              alterado: 0,
                              caso: 2,
                              statusAnterior:
                                await qualStatusAtualPeriodoUsuario(q.id),
                            };
                            situacaoAnteriorPrincipal = qualSituacao(
                              0,
                              0,
                              0,
                              0,
                              2,
                              q.situacao
                            );
                            formDataPrincipal.current = {
                              status: "ALTERANDO",
                              periodoUsuario: q.fracionamento,
                              situacaoAnterior: situacaoAnteriorPrincipal,
                              caso: 2,
                              statusAnterior:
                                await qualStatusAtualPeriodoUsuario(
                                  q.fracionamento
                                ),
                            };
                            p.children.filter(async (z: any) => {
                              if (
                                z.fracionamento === q.fracionamento &&
                                q.id !== z.id
                              ) {
                                periodoUsuario2Fracao = q.id;
                                situacaoAnterior2 = qualSituacao(
                                  0,
                                  0,
                                  0,
                                  0,
                                  2,
                                  q.situacao
                                );
                                formData2.current = {
                                  status: "ALTERANDO",
                                  periodoUsuario: z.id,
                                  situacaoAnterior: situacaoAnterior2,
                                  caso: 2,
                                  statusAnterior:
                                    await qualStatusAtualPeriodoUsuario(z.id),
                                };
                              }
                            });
                          }
                        });
                      }
                    }
                  });
                }
              }
            }
          }

          ////

          return disponibilizarPeriodo.filter(async (p: any) => {
            if ((await p.id) === periodoUsuario.current) {
              try {
                const response = await axios.put(URL, formData, {
                  headers: { Authorization: Token.AuthStr },
                });
                if (response) {
                  if (atualizandoFracao) {
                    return 1;
                  } else {
                    let formDataEmail = {
                      tipoEmail: 16,

                      periodoUsuarioId: periodoUsuario.current,
                      situacao: "Alugar ou trocar",
                      valorMin: valor.current,
                    };
                    let resultEmail;
                    if (await divulgando) {
                      resultEmail = true;
                    } else {
                      resultEmail = enviarEmail(formDataEmail);
                    }

                    if (await resultEmail) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                      return p;
                    } else {
                      error(
                        "Tivemos um problema no envio de e-mail de comprovação."
                      );
                      return p;
                    }
                  }
                } else {
                  error("Algo deu errado!");
                  return null;
                }
              } catch (error) {
                error("Algo deu errado!");
                return null;
              }
            } else {
              if (p.children) {
                p.children.filter(async (q: any) => {
                  if (q.id === periodoUsuario.current) {
                    const URLPrincipal = `${Globais.DOMINIOBACK}/periodo-usuario/${q.fracionamento}`;
                    let formDataPrincipal = {
                      status: "SEM_STATUS",
                    };
                    //aqui
                    try {
                      const responseFilho = await axios.put(URL, formData, {
                        headers: { Authorization: Token.AuthStr },
                      });
                      if (responseFilho) {
                        let responsePai;
                        if (
                          !(
                            statusAtual.current === "DELEGADO" ||
                            statusAtual.current === "NAO_PERTUBE"
                          )
                        ) {
                          responsePai = await axios.put(
                            URLPrincipal,
                            formDataPrincipal,
                            {
                              headers: { Authorization: Token.AuthStr },
                            }
                          );
                        } else {
                          responsePai = true;
                        }

                        if (responsePai) {
                          if (atualizandoFracao) {
                            return 1;
                          } else {
                            let formDataEmail = {
                              tipoEmail: 16,

                              periodoUsuarioId: periodoUsuario.current,
                              situacao: "Alugar ou trocar",
                              valorMin: valor.current,
                            };
                            let resultEmail;
                            if (await divulgando) {
                              resultEmail = true;
                            } else {
                              resultEmail = enviarEmail(formDataEmail);
                            }
                            if (await resultEmail) {
                              success("Período atualizado com sucesso!");
                              setTimeout(() => {
                                document.location.reload();
                              }, 2000);
                              return 1;
                            } else {
                              error(
                                "Tivemos um problema no envio de e-mail de comprovação."
                              );
                              return 0;
                            }
                          }
                        } else {
                          error("Algo deu errado!");
                          return 0;
                        }
                      } else {
                        error("Algo deu errado!");
                        return 0;
                      }
                    } catch (error) {
                      error("Algo deu errado!");
                      return 0;
                    }
                  }
                });
              }
            }
          });
        } else {
          document.location.href = "/";
          return 0;
        }
      }
    }
  };
  const criarPeriodosFracionados = async (valuesFracao: any) => {
    const Token = validateToken();

    if (valuesFracao.checkIn1 === undefined) {
      valuesFracao.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracao.checkOut1 === undefined) {
      valuesFracao.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracao.checkIn2 === undefined) {
      valuesFracao.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracao.checkOut2 === undefined) {
      valuesFracao.checkOut2 = checkOutPeriodo.current;
    }

    //  const valorMin = valor.current;

    if (Token) {
      const URLPeriodoGet = `${Globais.DOMINIOBACK}/periodo/${periodo.current}`;

      try {
        const responsePeriodoGet = await axios.get(URLPeriodoGet, {
          headers: { Authorization: Token.AuthStr },
        });

        if (responsePeriodoGet) {
          const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/`;
          let formDataPeriodo1 = {
            cotaId: responsePeriodoGet.data.cotaId,
            checkIn: AlterarFormatoData(valuesFracao.checkIn1),
            checkOut: AlterarFormatoData(valuesFracao.checkOut1),
            fracionamento: responsePeriodoGet.data.id,

            origem: Token.id,
          };

          try {
            const responseCriarPeriodo1 = await axios.post(
              URLPeriodo,
              formDataPeriodo1,
              {
                headers: { Authorization: Token.AuthStr },
              }
            );
            if (responseCriarPeriodo1) {
              let formDataPeriodoUsuario1 = {};
              const URLPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
              if (alugarOuTrocar.current === 1) {
                if (statusAtual.current === "DELEGADO") {
                  formDataPeriodoUsuario1 = {
                    alugar: 1,
                    trocar: 0,
                    concluido: 0,
                    utilizar: 0,
                    alterado: 1,
                    valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                    periodoId: responseCriarPeriodo1.data.id,
                    cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                    fracionamento: periodoUsuario.current,
                    status: "DELEGADO",
                  };
                } else {
                  if (statusAtual.current === "NAO_PERTUBE") {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,
                      alterado: 1,
                      valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,
                      status: "NAO_PERTUBE",
                    };
                  } else {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,
                      alterado: 1,
                      valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,
                      status: "SEM_STATUS",
                    };
                  }
                }
              } else {
                if (alugarOuTrocar.current === 2) {
                  if (statusAtual.current === "DELEGADO") {
                    formDataPeriodoUsuario1 = {
                      alugar: 1,
                      trocar: 1,
                      concluido: 0,
                      utilizar: 0,
                      alterado: 1,
                      valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                      periodoId: responseCriarPeriodo1.data.id,
                      cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                      fracionamento: periodoUsuario.current,
                      status: "DELEGADO",
                    };
                  } else {
                    if (statusAtual.current === "NAO_PERTUBE") {
                      formDataPeriodoUsuario1 = {
                        alugar: 1,
                        trocar: 1,
                        concluido: 0,
                        utilizar: 0,
                        alterado: 1,
                        valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                        periodoId: responseCriarPeriodo1.data.id,
                        cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                        fracionamento: periodoUsuario.current,
                        status: "NAO_PERTUBE",
                      };
                    } else {
                      formDataPeriodoUsuario1 = {
                        alugar: 1,
                        trocar: 1,
                        concluido: 0,
                        utilizar: 0,
                        alterado: 1,
                        valorMin: formatarMoeda(valorPrimeiroPeriodo.current),
                        periodoId: responseCriarPeriodo1.data.id,
                        cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                        fracionamento: periodoUsuario.current,
                        status: "SEM_STATUS",
                      };
                    }
                  }
                }
              }

              const responseCriarPeriodoUsuario1 = await axios.post(
                URLPeriodoUsuario,
                formDataPeriodoUsuario1,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseCriarPeriodoUsuario1) {
                periodoUsuario1Fracao.current =
                  responseCriarPeriodoUsuario1.data.id;
                let formDataPeriodo2 = {
                  cotaId: responsePeriodoGet.data.cotaId,
                  checkIn: AlterarFormatoData(valuesFracao.checkIn2),
                  checkOut: AlterarFormatoData(valuesFracao.checkOut2),
                  fracionamento: responsePeriodoGet.data.id,

                  origem: Token.id,
                };
                try {
                  const responseCriarPeriodo2 = await axios.post(
                    URLPeriodo,
                    formDataPeriodo2,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCriarPeriodo2) {
                    let formDataPeriodoUsuario2 = {};
                    if (alugarOuTrocar.current === 1) {
                      if (statusAtual.current === "DELEGADO") {
                        formDataPeriodoUsuario2 = {
                          alugar: 1,
                          trocar: 0,
                          concluido: 0,
                          utilizar: 0,
                          alterado: 1,
                          valorMin: formatarMoeda(valorSegundoPeriodo.current),
                          periodoId: responseCriarPeriodo2.data.id,
                          cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                          fracionamento: periodoUsuario.current,
                          status: "DELEGADO",
                        };
                      } else {
                        if (statusAtual.current === "NAO_PERTUBE") {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 0,
                            concluido: 0,
                            utilizar: 0,
                            alterado: 1,
                            valorMin: formatarMoeda(
                              valorSegundoPeriodo.current
                            ),
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                            status: "NAO_PERTUBE",
                          };
                        } else {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 0,
                            concluido: 0,
                            utilizar: 0,
                            alterado: 1,
                            valorMin: formatarMoeda(
                              valorSegundoPeriodo.current
                            ),
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                            status: "SEM_STATUS",
                          };
                        }
                      }
                    } else {
                      if (alugarOuTrocar.current === 2) {
                        if (statusAtual.current === "DELEGADO") {
                          formDataPeriodoUsuario2 = {
                            alugar: 1,
                            trocar: 1,
                            concluido: 0,
                            utilizar: 0,
                            alterado: 1,
                            valorMin: formatarMoeda(
                              valorSegundoPeriodo.current
                            ),
                            periodoId: responseCriarPeriodo2.data.id,
                            cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                            fracionamento: periodoUsuario.current,
                            status: "DELEGADO",
                          };
                        } else {
                          if (statusAtual.current === "NAO_PERTUBE") {
                            formDataPeriodoUsuario2 = {
                              alugar: 1,
                              trocar: 1,
                              concluido: 0,
                              utilizar: 0,
                              alterado: 1,
                              valorMin: formatarMoeda(
                                valorSegundoPeriodo.current
                              ),
                              periodoId: responseCriarPeriodo2.data.id,
                              cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                              fracionamento: periodoUsuario.current,
                              status: "NAO_PERTUBE",
                            };
                          } else {
                            formDataPeriodoUsuario2 = {
                              alugar: 1,
                              trocar: 1,
                              concluido: 0,
                              utilizar: 0,
                              alterado: 1,
                              valorMin: formatarMoeda(
                                valorSegundoPeriodo.current
                              ),
                              periodoId: responseCriarPeriodo2.data.id,
                              cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
                              fracionamento: periodoUsuario.current,
                              status: "SEM_STATUS",
                            };
                          }
                        }
                      }
                    }

                    try {
                      const responseCriarPeriodoUsuario2 = await axios.post(
                        URLPeriodoUsuario,
                        formDataPeriodoUsuario2,
                        {
                          headers: { Authorization: Token.AuthStr },
                        }
                      );
                      if (responseCriarPeriodoUsuario2) {
                        periodoUsuario2Fracao.current =
                          responseCriarPeriodoUsuario2.data.id;

                        return 1;
                      } else {
                        error("Algo deu errado!");
                      }
                    } catch (error) {
                      console.log(
                        "Não foi possível criar o segundo período do usuário"
                      );
                      error("Algo deu errado!");
                    }
                  }
                } catch (error) {
                  console.log("Não foi possível criar o segundo período");
                  error("Algo deu errado!");
                }
              }
            }
          } catch (error) {
            console.log("Não foi possível criar a fração de período");
            error("Algo deu errado!");
          }
        }
      } catch (error) {
        console.log("Não foi possível saber qual período pai.");
        error("Algo deu errado!");
      }
    }
  };

  // const atualizarValorAluguelEmLote = async (
  //   periodoUsuarioId: any,
  //   tipo: number
  // ) => {
  //   const Token = validateToken();

  //   const valorMin = valor.current;
  //   if (tipo === 1) {
  //     let formData = {
  //       alugar: 1,
  //       trocar: 0,
  //       concluido: 0,
  //       utilizar: 0,
  //       valorMin: valorMin,
  //     };

  //     if (Token) {
  //       for (let i = 0; i < selectedRowKeys.length; i++) {
  //         const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

  //         try {
  //           const response = await axios.put(URL, formData, {
  //             headers: { Authorization: Token.AuthStr },
  //           });
  //           if (response) {
  //             if (i === selectedRowKeys.length - 1) {
  //               success("Períodos atualizados com sucesso!");
  //               setTimeout(() => {
  //                 document.location.reload();
  //               }, 2000);
  //             }
  //           } else {
  //             error("Algo deu errado!");
  //           }
  //         } catch (error) {
  //           error("Algo deu errado!");
  //         }
  //       }
  //     }
  //   } else {
  //     if (tipo === 2) {
  //       let formData = {
  //         alugar: 1,
  //         trocar: 1,
  //         concluido: 0,
  //         utilizar: 0,
  //         valorMin: valorMin,
  //       };
  //       if (Token) {
  //         for (let i = 0; i < selectedRowKeys.length; i++) {
  //           const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

  //           try {
  //             const response = await axios.put(URL, formData, {
  //               headers: { Authorization: Token.AuthStr },
  //             });
  //             if (response) {
  //               if (i === selectedRowKeys.length - 1) {
  //                 success("Períodos atualizados com sucesso!");
  //                 setTimeout(() => {
  //                   document.location.reload();
  //                 }, 2000);
  //               }
  //             } else {
  //               error("Algo deu errado!");
  //             }
  //           } catch (error) {
  //             error("Algo deu errado!");
  //           }
  //         }
  //       }
  //     }
  //   }
  // };

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setFilteredInfo({
      checkIn: filters.checkIn,
      checkOut: filters.checkOut,
      especial: filters.especial,
      situacao: filters.situacao,

      status: filters.status,
    });

    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageDispPeriodo", page);
    }

    localStorage.setItem("filtrosDispPeriodo", JSON.stringify(filters));
    setSemFiltros(false);
  };

  const AbrirModalValor = () => {
    setOpenModalPerguntaFracaoCompleta(false);

    setOpenValor(true);
  };

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const Trocar = async (Token: any, periodoUsuarioId: number) => {
    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuarioId);

    let periodoUsuario1Fracao = 0;
    let periodoUsuario2Fracao = 0;
    let valorPrincipal = 0;
    let valor1Fracao = 0;
    let valor2Fracao = 0;

    let situacaoAnterior1;
    let situacaoAnterior2;
    let situacaoAnteriorPrincipal;
    let temFracoes = false;

    if (await divulgando) {
      disponibilizarPeriodo.map((p: any) => {
        if (p.id === periodoUsuario.current) {
          situacaoAnteriorPrincipal = qualSituacao(0, 0, 0, 0, 2, p.situacao);
          formDataPrincipal.current = {
            alugar: 0,
            trocar: 1,
            utilizar: 0,
            concluido: 0,
            alterado: 0,
            status: "ALTERANDO",
            periodoUsuario: p.id,
            situacaoAnterior: situacaoAnteriorPrincipal,
            caso: 2,
          };

          if (p.children) {
            temFracoes = true;

            p.children.filter((q: any) => {
              if (q.fracionamento === p.id) {
                if (periodoUsuario1Fracao === 0) {
                  periodoUsuario1Fracao = q.id;
                  situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                  formData1.current = {
                    status: "ALTERANDO",
                    periodoUsuario: q.id,
                    situacaoAnterior: situacaoAnterior1,
                    caso: 2,
                  };
                } else {
                  periodoUsuario2Fracao = q.id;
                  situacaoAnterior2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                  formData2.current = {
                    status: "ALTERANDO",
                    periodoUsuario: q.id,
                    situacaoAnterior: situacaoAnterior2,
                    caso: 2,
                  };
                }
              }
            });
          }
        } else {
          if (p.children) {
            p.children.filter((q: any) => {
              if (q.id === periodoUsuario.current) {
                temFracoes = true;
                periodoUsuario1Fracao = q.id;
                situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);

                formData1.current = {
                  status: "ALTERANDO",
                  periodoUsuario: q.id,
                  situacaoAnterior: situacaoAnterior1,
                  alugar: 0,
                  trocar: 1,
                  utilizar: 0,
                  concluido: 0,
                  alterado: 0,
                  caso: 2,
                };
                situacaoAnteriorPrincipal = qualSituacao(
                  0,
                  0,
                  0,
                  0,
                  2,
                  q.situacao
                );
                formDataPrincipal.current = {
                  status: "ALTERANDO",
                  periodoUsuario: q.fracionamento,
                  situacaoAnterior: situacaoAnteriorPrincipal,
                  caso: 2,
                };
                p.children.filter((z: any) => {
                  if (z.fracionamento === q.fracionamento && q.id !== z.id) {
                    periodoUsuario2Fracao = q.id;
                    situacaoAnterior2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                    formData2.current = {
                      status: "ALTERANDO",
                      periodoUsuario: z.id,
                      situacaoAnterior: situacaoAnterior2,
                      caso: 2,
                    };
                  }
                });
              }
            });
          }
        }
      });
    } else {
      disponibilizarPeriodo.map(async (p: any) => {
        if (p.id === periodoUsuario.current) {
          formDataPrincipal.current = {
            alugar: 0,
            trocar: 1,
            utilizar: 0,
            concluido: 0,
            alterado: 0,
            status: "SEM_STATUS",
            periodoUsuario: p.id,

            caso: 2,
          };
        } else {
          if (p.children) {
            p.children.filter((q: any) => {
              if (q.id === periodoUsuario.current) {
                periodoUsuario1Fracao = q.id;
                situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);

                formDataPrincipal.current = {
                  status: "SEM_STATUS",
                  periodoUsuario: q.id,

                  alugar: 0,
                  trocar: 1,
                  utilizar: 0,
                  concluido: 0,
                  alterado: 0,
                  caso: 2,
                };
              }
            });
          }
        }
      });
    }

    const result1 = atualizarPeriodoUsuario(formDataPrincipal.current);
    valorPrincipal = 10;

    if (temFracoes) {
      if ((await result1) === 1) {
        const result2 = atualizarPeriodoUsuario(formData1.current);
        valor1Fracao = 10;

        if ((await result2) === 1) {
          const result3 = atualizarPeriodoUsuario(formData2.current);
          valor2Fracao = 10;

          if ((await result3) === 1) {
            successLongaDuracao("Períodos atualizados com sucesso!");
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          } else {
            error("Não foi possível atualizar o segundo período.");
          }
        } else {
          error("Não foi possível atualizar o primeiro período.");
        }
      } else {
        error("Não foi possível atualizar o período principal.");
      }
    }

    let formDataEmail = {
      tipoEmail: 18,
      periodoUsuarioId: periodoUsuario.current,
      valorPrincipal: valorPrincipal,
      valor1Fracao: valor1Fracao,
      valor2Fracao: valor2Fracao,
    };
    let resultEmail;
    if (await divulgando) {
      resultEmail = 1;
    } else {
      resultEmail = enviarEmail(formDataEmail);
    }
    if (temFracoes) {
      return 1;
    } else {
      if (await resultEmail) {
        success("Período atualizado com sucesso!");
        setTimeout(() => {
          document.location.reload();
        }, 2000);
      } else {
        error("Não poi possível enviar e-mail de comprovação.");
      }
    }
  };

  const Utilizar = async (Token: any, periodoUsuarioId: number) => {
    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuarioId);
    let periodoUsuario1Fracao = 0;
    let periodoUsuario2Fracao = 0;
    let valorPrincipal = 0;
    let valor1Fracao = 0;
    let valor2Fracao = 0;

    let situacaoAnterior1;
    let situacaoAnterior2;
    let situacaoAnteriorPrincipal;
    let temFracoes = false;

    if (await divulgando) {
      disponibilizarPeriodo.map((p: any) => {
        if (p.id === periodoUsuario.current) {
          situacaoAnteriorPrincipal = qualSituacao(0, 0, 0, 0, 2, p.situacao);
          formDataPrincipal.current = {
            alugar: 0,
            trocar: 0,
            utilizar: 1,
            concluido: 0,
            alterado: 0,
            status: "ALTERANDO",
            periodoUsuario: p.id,
            situacaoAnterior: situacaoAnteriorPrincipal,
            caso: 2,
          };

          if (p.children) {
            temFracoes = true;

            p.children.filter((q: any) => {
              if (q.fracionamento === p.id) {
                if (periodoUsuario1Fracao === 0) {
                  periodoUsuario1Fracao = q.id;
                  situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                  formData1.current = {
                    status: "ALTERANDO",
                    periodoUsuario: q.id,
                    situacaoAnterior: situacaoAnterior1,
                    caso: 2,
                  };
                } else {
                  periodoUsuario2Fracao = q.id;
                  situacaoAnterior2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                  formData2.current = {
                    status: "ALTERANDO",
                    periodoUsuario: q.id,
                    situacaoAnterior: situacaoAnterior2,
                    caso: 2,
                  };
                }
              }
            });
          }
        } else {
          if (p.children) {
            p.children.filter((q: any) => {
              if (q.id === periodoUsuario.current) {
                temFracoes = true;
                periodoUsuario1Fracao = q.id;
                situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);

                formData1.current = {
                  status: "ALTERANDO",
                  periodoUsuario: q.id,
                  situacaoAnterior: situacaoAnterior1,
                  alugar: 0,
                  trocar: 0,
                  utilizar: 1,
                  concluido: 0,
                  alterado: 0,
                  caso: 2,
                };
                situacaoAnteriorPrincipal = qualSituacao(
                  0,
                  0,
                  0,
                  0,
                  2,
                  q.situacao
                );
                formDataPrincipal.current = {
                  status: "ALTERANDO",
                  periodoUsuario: q.fracionamento,
                  situacaoAnterior: situacaoAnteriorPrincipal,
                  caso: 2,
                };
                p.children.filter((z: any) => {
                  if (z.fracionamento === q.fracionamento && q.id !== z.id) {
                    periodoUsuario2Fracao = q.id;
                    situacaoAnterior2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                    formData2.current = {
                      status: "ALTERANDO",
                      periodoUsuario: z.id,
                      situacaoAnterior: situacaoAnterior2,
                      caso: 2,
                    };
                  }
                });
              }
            });
          }
        }
      });
    } else {
      disponibilizarPeriodo.map(async (p: any) => {
        if (p.id === periodoUsuario.current) {
          formDataPrincipal.current = {
            alugar: 0,
            trocar: 0,
            utilizar: 1,
            concluido: 0,
            alterado: 0,
            status: "FINALIZADO",
            periodoUsuario: p.id,

            caso: 2,
          };
        } else {
          if (p.children) {
            p.children.filter((q: any) => {
              if (q.id === periodoUsuario.current) {
                periodoUsuario1Fracao = q.id;
                situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);

                formDataPrincipal.current = {
                  status: "FINALIZADO",
                  periodoUsuario: q.id,

                  alugar: 0,
                  trocar: 0,
                  utilizar: 1,
                  concluido: 0,
                  alterado: 0,
                  caso: 2,
                };
              }
            });
          }
        }
      });
    }

    const result1 = atualizarPeriodoUsuario(formDataPrincipal.current);
    valorPrincipal = 9;

    if (temFracoes) {
      if ((await result1) === 1) {
        const result2 = atualizarPeriodoUsuario(formData1.current);
        valor1Fracao = 9;

        if ((await result2) === 1) {
          const result3 = atualizarPeriodoUsuario(formData2.current);
          valor2Fracao = 9;

          if ((await result3) === 1) {
            successLongaDuracao("Períodos atualizados com sucesso!");
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          } else {
            error("Não foi possível atualizar o segundo período.");
          }
        } else {
          error("Não foi possível atualizar o primeiro período.");
        }
      } else {
        error("Não foi possível atualizar o período principal.");
      }
    }

    let formDataEmail = {
      tipoEmail: 18,
      periodoUsuarioId: periodoUsuario.current,
      valorPrincipal: valorPrincipal,
      valor1Fracao: valor1Fracao,
      valor2Fracao: valor2Fracao,
    };
    let resultEmail;
    if (await divulgando) {
      resultEmail = 1;
    } else {
      resultEmail = enviarEmail(formDataEmail);
    }
    if (temFracoes) {
      return 1;
    } else {
      if (await resultEmail) {
        success("Período atualizado com sucesso!");
        setTimeout(() => {
          document.location.reload();
        }, 2000);
      } else {
        error("Não poi possível enviar e-mail de comprovação.");
      }
    }
  };

  const montarFormData = (p: any, status: string, caso = 2, extra = {}) => ({
    status,
    periodoUsuario: p.id,
    situacaoAnterior: qualSituacao(0, 0, 0, 0, 2, p.situacao),
    caso,
    ...extra,
  });

  const atualizarEVerificar = async (formData: any, label: string) => {
    const result = await atualizarPeriodoUsuario(formData);
    if (result !== 1) {
      error(`Não foi possível atualizar ${label}.`);
      return false;
    }
    return true;
  };

  const Reservar = async (
    Token: any,
    periodoUsuarioId: number,
    valorMin?: number
  ) => {
    const divulgando = await verificarSeTemPeriodoDivulgado(periodoUsuarioId);

    const periodoAtual = periodoUsuario.current;

    let valorPrincipal = 0;
    let valor1Fracao = 0;
    let valor2Fracao = 0;
    let temFracoes = false;

    let formPrincipal: any = null;
    let formFracao1: any = null;
    let formFracao2: any = null;

    for (const p of disponibilizarPeriodo) {
      const ehPrincipal = p.id === periodoAtual;
      const filhos = p.children || [];

      if (ehPrincipal) {
        formPrincipal = montarFormData(
          p,
          divulgando ? "ALTERANDO" : "FINALIZADO",
          2,
          divulgando
            ? {}
            : {
                alugar: 0,
                trocar: 0,
                utilizar: 0,
                concluido: 1,
                alterado: 0,
                valorMin: valorMin ? valorMin : null,
              }
        );

        const fracoes = filhos.filter((f: any) => f.fracionamento === p.id);
        if (fracoes.length > 0) {
          temFracoes = true;
          formFracao1 = montarFormData(fracoes[0], "ALTERANDO", 2);
          if (fracoes[1]) {
            formFracao2 = montarFormData(fracoes[1], "ALTERANDO", 2);
          }
        }
      } else {
        for (const f of filhos) {
          if (f.id === periodoAtual) {
            temFracoes = true;
            formFracao1 = montarFormData(
              f,
              divulgando ? "ALTERANDO" : "FINALIZADO",
              2,
              divulgando
                ? {}
                : {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 0,
                    concluido: 1,
                    alterado: 0,
                    valorMin: valorMin ? valorMin : null,
                  }
            );

            const irmas = filhos.filter(
              (z: any) => z.fracionamento === f.fracionamento && z.id !== f.id
            );
            if (irmas[0]) {
              formFracao2 = montarFormData(irmas[0], "ALTERANDO", 2);
            }

            const pai = disponibilizarPeriodo.find(
              (pai: any) => pai.id === f.fracionamento
            );
            if (pai) {
              formPrincipal = montarFormData(pai, "ALTERANDO", 2);
            }
          }
        }
      }
    }

    if (formPrincipal) {
      const ok1 = await atualizarEVerificar(
        formPrincipal,
        "o período principal"
      );
      valorPrincipal = 8;

      if (temFracoes && ok1) {
        const ok2 = formFracao1
          ? await atualizarEVerificar(formFracao1, "a primeira fração")
          : true;
        valor1Fracao = formFracao1 ? 8 : 0;

        const ok3 = formFracao2
          ? await atualizarEVerificar(formFracao2, "a segunda fração")
          : true;
        valor2Fracao = formFracao2 ? 8 : 0;

        if (ok2 && ok3) {
          successLongaDuracao("Períodos atualizados com sucesso!");
          setTimeout(() => window.location.reload(), 2000);
        }
        return;
      }

      if (!temFracoes) {
        const formDataEmail = {
          tipoEmail: 18,
          periodoUsuarioId: periodoAtual,
          valorPrincipal,
          valor1Fracao,
          valor2Fracao,
          valorMin: valorMin ? valorMin : null,
        };

        const emailEnviado = divulgando
          ? true
          : await enviarEmail(formDataEmail);
        if (emailEnviado) {
          success("Período atualizado com sucesso!");
          setTimeout(() => window.location.reload(), 2000);
        } else {
          error("Não foi possível enviar e-mail de comprovação.");
        }
      }
    }
  };

  const [showAlert, setShowAlert] = useState(false);

  const onClick = async ({
    key,
    situacao: situacaoRecebida,
    checkOutPeriodo: checkOutRecebido,
    checkInPeriodo: checkInPeriodoRecebido,
    statusAtual: statusAtualRecebido,
    statusAnterior: statusAnteriorRecebido,
    periodoUsuario: periodoUsuarioRecebido,
    valorSugeridoSistema: valorSugeridoSistemaRecebido,
    valorSugeridoSistema1Fracao: valorSugeridoSistema1FracaoRecebido,
    valorSugeridoSistema2Fracao: valorSugeridoSistema2FracaoRecebido,
    periodo: periodoRecebido,
  }: any) => {
    const Token = validateToken();
    const perfil = Token?.nda;

    if (isMobile) {
      situacao.current = situacaoRecebida;
      checkOutPeriodo.current = checkOutRecebido;
      statusAtual.current = statusAtualRecebido;
      statusAnterior.current = statusAnteriorRecebido;
      periodoUsuario.current = periodoUsuarioRecebido;
      checkInPeriodo.current = checkInPeriodoRecebido;
      valorSugeridoSistema.current = valorSugeridoSistemaRecebido;
      valorSugeridoSistema1Fracao.current = valorSugeridoSistema1FracaoRecebido;
      valorSugeridoSistema2Fracao.current = valorSugeridoSistema2FracaoRecebido;
      periodo.current = periodoRecebido;
    }

    if (
      periodoUsuario.current === 0 &&
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        //Delegar
        case "1": {
           handleFechar();
          const periodoJaPassou = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );
          const situacoesInvalidas = [
            "Não definido",
            "Trocar",
            "Reservado pelo próprio",
            "Será utilizado",
          ];

          if (situacoesInvalidas.includes(situacao.current)) {
            return error(
              'A opção "Delegar" só é válida em períodos que estejam nas situações "Alugar" ou "Alugar ou trocar".'
            );
          }

          if (periodoJaPassou) {
            return error("Esse período já passou!");
          }

          if (situacao.current === "Períodos fracionados reservados") {
            return error(
              "Esse período tem frações reservadas e por isso não pode ser alterado."
            );
          }

          if (situacao.current === "Reservado por MC") {
            return error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            return error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
            );
          }

          if (statusAtual.current === "ALTERANDO") {
            return errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
          }

          disponibilizarPeriodo.forEach(async (periodo: any) => {
            const isPeriodoPrincipal = periodo.id === periodoUsuario.current;

            if (isPeriodoPrincipal) {
              return statusAtual.current === "DELEGADO"
                ? setOpenRetirarDelegar(true)
                : setOpenDelegar(true);
            }

            const temFilhoCorrespondente = periodo.children?.some(
              (child: any) => child.id === periodoUsuario.current
            );

            if (temFilhoCorrespondente) {
              return error(
                "Essa ação só pode ser realizada no período principal."
              );
            }
          });

          break;
        }
        //Alugar
        case "2":
          // Colocar na situação de alugar
          setTitleFracaoCompleta(false);
           handleFechar();
          valorSugeridoSistema1Fracao.current = "";
          valorSugeridoSistema2Fracao.current = "";

          const periodoAntigo = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );
          if (periodoAntigo) {
            return error("Esse período já passou!");
          }

          if (situacao.current === "Reservado por MC") {
            return error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            return error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
            );
          }

          if (situacao.current === "Períodos fracionados reservados") {
            return error(
              "Esse período tem frações reservadas e por isso não pode ser alterado."
            );
          }

          if (statusAtual.current === "ALTERANDO") {
            return errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
          }

          alugarOuTrocar.current = 1;

          const periodoDivulgado = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          for (const p of disponibilizarPeriodo) {
            if (p.id === periodoUsuario.current) {
              const diaSemana = retornaDiaDaSemana(checkInPeriodo.current);
              let checkOutNovo;

              if (diaSemana === 0) {
                checkOutNovo = adicionarDiasData(checkInPeriodo.current, 4);
              } else if ([4, 5, 6].includes(diaSemana)) {
                checkOutNovo = adicionarDiasData(checkInPeriodo.current, 3);
              }

              if (checkOutNovo) {
                setSugestaoCheckOut(checkOutNovo);

                if (valorSugeridoSistema.current) {
                  valorSugeridoSistema1Fracao.current =
                    await retornarValorAtualizado(
                      valorSugeridoSistema.current,
                      checkInPeriodo.current,
                      checkOutNovo,
                      3
                    );

                  valorSugeridoSistema2Fracao.current =
                    await retornarValorAtualizado(
                      valorSugeridoSistema.current,
                      checkOutNovo,
                      checkOutPeriodo.current,
                      3
                    );
                }
              }

              if (p.children) {
                atualizando.current = true;
                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  return error(
                    "Esse período contém frações que já foram reservados. Dessa forma não será possível alterá-lo."
                  );
                }

                if (resultado === 2) {
                  return errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período, favor alterar a situação dessa fração."
                  );
                }
              }

              fracionando.current = true;
              return periodoDivulgado
                ? setOpenAlterandoDivulgado(true)
                : setOpenModalPerguntaFracaoCompleta(true);
            }

            // Verificar filhos
            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  fracionando.current = false;
                  return periodoDivulgado
                    ? setOpenAlterandoDivulgado(true)
                    : AbrirModalValor();
                }
              }
            }
          }

          break;
        //Trocar
        case "3":
          //Trocar
          if (situacao.current === "Trocar") {
            error("A situação já está como trocar.");
            break;
          }
          handleFechar();

          const interesse = await verificarInteresse();
          if (!interesse) {
            setShowAlert(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
              window.location.href = "/interesses";
            }, 5000);
            break;
          }

          if (validateDataCheckOutMaior(checkOutPeriodo.current, hoje)) {
            error("Esse período já passou!");
            break;
          }

          if (situacao.current === "Reservado por MC") {
            error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            error(
              "Esse período tem frações reservadas e por isso não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Períodos fracionados reservados") {
            error(
              "Esse período tem frações reservadas e por isso não pode ser alugado."
            );
            break;
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
            break;
          }

          if (!Token) {
            document.location.href = "/";
            break;
          }

          const divulgando = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          for (const p of disponibilizarPeriodo) {
            if ((await p.id) === periodoUsuario.current) {
              if (p.children) {
                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  error(
                    "Esse período contém frações que já foram reservados. Dessa forma não será possível alterar."
                  );
                  break;
                }

                if (resultado === 2) {
                  errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período favor alterar a situação dessa fração."
                  );
                  break;
                }

                excluindoFracionados.current = true;
                reservandoOuUtilizandoOuTrocando.current = "trocando";

                if (divulgando) {
                  setOpenAlterandoDivulgado(true);
                } else {
                  setOpenExcluirFracionados(true);
                }

                break;
              } else {
                reservandoOuUtilizandoOuTrocando.current = "trocando";

                if (divulgando) {
                  setOpenAlterandoDivulgado(true);
                } else {
                  Trocar(Token, periodoUsuario.current);
                }

                break;
              }
            }

            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  reservandoOuUtilizandoOuTrocando.current = "trocando";

                  if (divulgando) {
                    setOpenAlterandoDivulgado(true);
                  } else {
                    Trocar(Token, periodoUsuario.current);
                  }

                  break;
                }
              }
            }
          }

          break;
        //Alugar ou Trocar
        case "4":
          setTitleFracaoCompleta(false);
           handleFechar();

          valorSugeridoSistema1Fracao.current = "";
          valorSugeridoSistema2Fracao.current = "";

          if (validateDataCheckOutMaior(checkOutPeriodo.current, hoje)) {
            error("Esse período já passou!");
            break;
          }

          const interesse4 = await verificarInteresse();
          if (!interesse4) {
            setShowAlert(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
              window.location.href = "/interesses";
            }, 5000);
            break;
          }

          if (situacao.current === "Reservado por MC") {
            error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alugado."
            );
            break;
          }

          if (situacao.current === "Períodos fracionados reservados") {
            error(
              "Esse período tem frações reservadas e por isso não pode ser alugado."
            );
            break;
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
            break;
          }

          alugarOuTrocar.current = 2;

          const divulgando4 = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          for (const p of disponibilizarPeriodo) {
            if ((await p.id) === periodoUsuario.current) {
              const dias = retornaDiaDaSemana(checkInPeriodo.current);
              const diasAdicionais = [0].includes(dias) ? 4 : 3;
              const checkOutNovo = adicionarDiasData(
                checkInPeriodo.current,
                diasAdicionais
              );

              setSugestaoCheckOut(checkOutNovo);

              if (valorSugeridoSistema.current) {
                valorSugeridoSistema1Fracao.current =
                  await retornarValorAtualizado(
                    valorSugeridoSistema.current,
                    checkInPeriodo.current,
                    checkOutNovo,
                    3
                  );

                valorSugeridoSistema2Fracao.current =
                  await retornarValorAtualizado(
                    valorSugeridoSistema.current,
                    checkOutNovo,
                    checkOutPeriodo.current,
                    3
                  );
              }

              if (p.children) {
                atualizando.current = true;

                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  error(
                    "Esse período contém frações que já foram reservados. Dessa forma, não será possível alterar."
                  );
                  break;
                }

                if (resultado === 2) {
                  errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período, favor alterar a situação dessa fração."
                  );
                  break;
                }

                if (divulgando4) {
                  fracionando.current = true;
                  setOpenAlterandoDivulgado(true);
                } else {
                  setOpenModalPerguntaFracaoCompleta(true);
                }
              } else {
                if (divulgando4) {
                  fracionando.current = true;
                  setOpenAlterandoDivulgado(true);
                } else {
                  setOpenModalPerguntaFracaoCompleta(true);
                }
              }

              break;
            }

            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  if (divulgando4) {
                    fracionando.current = false;
                    setOpenAlterandoDivulgado(true);
                  } else {
                    AbrirModalValor();
                  }
                  break;
                }
              }
            }
          }

          break;
        //Será Utilizado
        case "5":
          // Colocar na situação "utilizar"
           handleFechar();
          if (situacao.current === "Será utilizado") {
            error("A situação já está como utilizado.");
            break;
          }

          if (validateDataCheckOutMaior(checkOutPeriodo.current, hoje)) {
            error("Esse período já passou!");
            break;
          }

          const situacoesInvalidas = [
            {
              cond: situacao.current === "Reservado por MC",
              msg: "Esse período já foi reservado pela Multicotas. Não pode ser alterado.",
            },
            {
              cond: situacao.current === "Alugado ou utilizado parcialmente",
              msg: "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alugado.",
            },
            {
              cond: situacao.current === "Períodos fracionados reservados",
              msg: "Esse período tem frações reservadas e por isso não pode ser alugado.",
            },
          ];

          for (const { cond, msg } of situacoesInvalidas) {
            if (cond) {
              error(msg);
              break;
            }
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
            break;
          }

          if (!Token) {
            window.location.href = "/";
            break;
          }

          const divulgando5 = verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          disponibilizarPeriodo.forEach(async (p: any) => {
            const isPeriodoAtual = (await p.id) === periodoUsuario.current;

            if (
              isPeriodoAtual ||
              (p.children &&
                p.children.some((q: any) => q.id === periodoUsuario.current))
            ) {
              const isChildMatch = !isPeriodoAtual;
              const targetChildren = isChildMatch
                ? p.children.filter((q: any) => q.id === periodoUsuario.current)
                : [];

              if (p.children && (isPeriodoAtual || targetChildren.length > 0)) {
                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  error(
                    "Esse período contém frações que já foram reservados. Dessa forma não será possível alterar."
                  );
                } else if (resultado === 2) {
                  errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período favor alterar a situação dessa fração."
                  );
                } else {
                  reservandoOuUtilizandoOuTrocando.current = "utilizando";
                  if (await divulgando5) {
                    excluindoFracionados.current = true;
                    setOpenAlterandoDivulgado(true);
                  } else {
                    setOpenExcluirFracionados(true);
                  }
                }
              } else {
                reservandoOuUtilizandoOuTrocando.current = "utilizando";
                if (await divulgando5) {
                  setOpenAlterandoDivulgado(true);
                } else {
                  Utilizar(Token, periodoUsuario.current);
                }
              }
            }
          });

          break;
        //Já Reservei
        case "6":
           handleFechar();
          if (situacao.current === "Reservado pelo próprio") {
            error("Esse período já está marcado como reservado.");
            break;
          }

          const periodoAntigo6 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );
          if (periodoAntigo6) {
            error("Esse período já passou!");
            break;
          }

          if (situacao.current === "Reservado por MC") {
            error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alugado."
            );
            break;
          }

          if (situacao.current === "Períodos fracionados reservados") {
            error(
              "Esse período tem frações reservadas e por isso não pode ser alugado."
            );
            break;
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
            break;
          }

          if (!Token) {
            document.location.href = "/";
            break;
          }

          const divulgando6 = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          for (const p of disponibilizarPeriodo) {
            const idMatch = (await p.id) === periodoUsuario.current;

            if (idMatch) {
              if (p.children) {
                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  error(
                    "Esse período contém frações que já foram reservados. Dessa forma não será possível alterar."
                  );
                  break;
                }

                if (resultado === 2) {
                  errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período favor alterar a situação dessa fração."
                  );
                  break;
                }

                reservandoOuUtilizandoOuTrocando.current = "reservando";
                if (divulgando6) {
                  excluindoFracionados.current = true;
                  setOpenAlterandoDivulgado(true);
                } else {
                  setOpenExcluirFracionados(true);
                }
              } else {
                reservandoOuUtilizandoOuTrocando.current = "reservando";
                if (divulgando6) {
                  setOpenAlterandoDivulgado(true);
                } else {
                  console.log(4);
                  setOpenModalReserva(true);

                  //Reservar(Token, periodoUsuario.current);
                }
              }

              break;
            }

            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  reservandoOuUtilizandoOuTrocando.current = "reservando";
                  if (await divulgando6) {
                    setOpenAlterandoDivulgado(true);
                  } else {
                    setOpenModalReserva(true);
                    //Reservar(Token, periodoUsuario.current);
                  }
                  break;
                }
              }
            }
          }

          break;
        //Não Pertube
        case "7":
          // não perturbe
           handleFechar();
          const periodoPassado7 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );

          const situacoesInvalidas7 = [
            "Não definido",
            "Trocar",
            "Reservado pelo próprio",
            "Será utilizado",
          ];

          if (situacoesInvalidas7.includes(situacao.current)) {
            error(
              'A opção "Não pertube" só é válida em períodos que estejam nas situações "Alugar" ou "Alugar ou trocar".'
            );
            break;
          }

          if (periodoPassado7) {
            error("Esse período já passou!");
            break;
          }

          if (situacao.current === "Períodos fracionados reservados") {
            error(
              "Esse período tem frações reservadas e por isso não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Reservado por MC") {
            error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
            break;
          }

          if (situacao.current === "Alugado ou utilizado parcialmente") {
            error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
            );
            break;
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou . Aguarde, em breve receberá um e-mail com a confirmação. "
            );
            break;
          }

          for (const p of disponibilizarPeriodo) {
            if (p.id === periodoUsuario.current) {
              if (statusAtual.current === "NAO_PERTUBE") {
                setOpenRetirarNaoPertube(true);
              } else {
                setOpenNaoPertube(true);
              }
              break;
            }

            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  error(
                    "Essa ação só pode ser realizada no período principal."
                  );
                  break;
                }
              }
            }
          }
          break;
        //Excluir Frações
        case "8":
          // Excluir frações
           handleFechar();

          const periodoPassado8 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );
          const estaDivulgando = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          if (periodoPassado8) {
            error("Esse período já passou!");
            break;
          }

          if (situacao.current === "Reservado por MC") {
            error(
              "Esse período já foi reservado pela Multicotas. Não pode ser alterado."
            );
            break;
          }

          if (
            situacao.current === "Alugado ou utilizado parcialmente" ||
            situacao.current === "Períodos fracionados reservados"
          ) {
            error(
              "Esse período tem alguma fração que não está mais disponível e por isso não pode ser alterado."
            );
            break;
          }

          if (statusAtual.current === "ALTERANDO") {
            errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou . Aguarde, em breve receberá um e-mail com a confirmação. "
            );
            break;
          }

          const temFracoes = verSeTemFracoes(
            periodoUsuario.current,
            disponibilizarPeriodo
          );

          if (!temFracoes) {
            error("Esse período não tem frações!");
            break;
          }

          for (const p of disponibilizarPeriodo) {
            if (p.id === periodoUsuario.current) {
              if (estaDivulgando) {
                excluindoFracionados.current = true;
                setOpenAlterandoDivulgado(true);
              } else {
                reservandoOuUtilizandoOuTrocando.current =
                  "apenasExcluindoFracao";
                setOpenExcluirFracionados(true);
              }
              break;
            }

            if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  error(
                    "Essa ação só poder ser realizada no período principal."
                  );
                  break;
                }
              }
            }
          }

          break;
        //Alterar Valor
        case "12":
          // Alterar valor
           handleFechar();

          setTitleFracaoCompleta(true);
          alterandoValor.current = true;

          const antigo12 = validateDataCheckOutMaior(
            checkOutPeriodo.current,
            hoje
          );

          if (situacao.current === "Não definido") {
            return error(
              'Esse período ainda não tem valor. Caso queira incluir um valor para esse período, selecione as opções "Alugar" ou "Alugar ou trocar".'
            );
          }

          if (antigo12) {
            return error("Esse período já passou!");
          }

          const situacoesInvalidas12 = [
            "Alugado ou utilizado parcialmente",
            "Períodos fracionados reservados",
            "Reservado por MC",
            "Reservado pelo próprio",
          ];

          if (situacoesInvalidas12.includes(situacao.current)) {
            return error(
              "Esse período não pode ser alterado devido ao seu status atual."
            );
          }

          if (statusAtual.current === "ALTERANDO") {
            return errorLongaDuracao(
              "Nesse momento, a Multicotas está ajustando algumas modificações que provavelmente você solicitou. Aguarde, em breve receberá um e-mail com a confirmação."
            );
          }

          const divulgando12 = await verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );

          for (const p of disponibilizarPeriodo) {
            const isPrincipal = p.id === periodoUsuario.current;

            const definirValorSugerido = async (dias: number) => {
              const checkOutNovo = adicionarDiasData(
                checkInPeriodo.current,
                dias
              );
              setSugestaoCheckOut(checkOutNovo);

              if (valorSugeridoSistema.current) {
                valorSugeridoSistema1Fracao.current =
                  await retornarValorAtualizado(
                    valorSugeridoSistema.current,
                    checkInPeriodo.current,
                    checkOutNovo,
                    3
                  );

                valorSugeridoSistema2Fracao.current =
                  await retornarValorAtualizado(
                    valorSugeridoSistema.current,
                    checkOutNovo,
                    checkOutPeriodo.current,
                    3
                  );
              }
            };

            if (isPrincipal) {
              const dias = retornaDiaDaSemana(checkInPeriodo.current);

              if (dias === 0) await definirValorSugerido(4);
              else if ([4, 5, 6].includes(dias)) await definirValorSugerido(3);

              alugarOuTrocar.current = p.situacao === "Alugar" ? 1 : 2;

              if (p.children) {
                atualizando.current = true;
                const resultado = verificarSituacaoFracionados(
                  "ViewDisponibilizacaoPeriodos",
                  periodoUsuario.current,
                  p.children
                );

                if (resultado === 1) {
                  return error(
                    "Esse período contém frações que já foram reservados. Dessa forma não será possível alterá-lo."
                  );
                } else if (resultado === 2) {
                  return errorLongaDuracao(
                    "Esse período contém frações que já foram comprometidas. Caso deseje alugar esse período, favor alterar a situação dessa fração."
                  );
                } else {
                  if (divulgando12) {
                    fracionando.current = true;
                    setOpenAlterandoDivulgado(true);
                  } else {
                    setOpenModalPerguntaFracaoCompleta(true);
                  }
                }
              } else {
                if (divulgando12) {
                  fracionando.current = false;
                  setOpenAlterandoDivulgado(true);
                } else {
                  setOpenValor(true);
                }
              }
            } else if (p.children) {
              for (const q of p.children) {
                if (q.id === periodoUsuario.current) {
                  alugarOuTrocar.current = q.situacao === "Alugar" ? 1 : 2;

                  if (divulgando12) {
                    fracionando.current = false;
                    setOpenAlterandoDivulgado(true);
                  } else {
                    setOpenValor(true);
                  }
                }
              }
            }
          }

          break;
      }
    }
  };

  const hideModal = () => {
    setOpenExcluir(false);
  };
  const hideModalFracionados = () => {
    setOpenExcluirFracionados(false);
  };
  const hideModalDelegar = () => {
    setOpenDelegar(false);
  };
  const hideModalRetirarDelegar = () => {
    setOpenRetirarDelegar(false);
  };
  const hideModalNaoPertube = () => {
    setOpenNaoPertube(false);
  };
  const hideModalRetirarNaoPertube = () => {
    setOpenRetirarNaoPertube(false);
  };
  const hideModalAlterarPeriodosDivulgados = () => {
    setOpenAlterandoDivulgado(false);
  };

  const items: MenuProps["items"] = [
    getItem(isAdmin == 1 ? "Alugar" : "Quero Alugar", "2"),
    getItem(isAdmin == 1 ? "Trocar" : "Quero Trocar", "3"),
    getItem(isAdmin == 1 ? "Alugar ou Trocar" : "Quero Alugar ou Trocar", "4"),
    getItem(isAdmin == 1 ? "Alterar Valor" : "Quero Alterar Valor", "12"),
    getItem(
      isAdmin == 1 ? "Será Utilizado" : "Será Utilizado ou Já Utilizei",
      "5"
    ),
    getItem(isAdmin == 1 ? "Já Reservei" : "Já Aluguei", "6"),
    getItem(isAdmin == 1 ? "Delegar" : "Já Troquei", "1"),
    getItem("Não pertube", "7"),
    getItem("Excluir frações", "8"),
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const excluirPeriodo = async () => {
    const Token = validateToken();

    const periodoUsuarioId = periodoUsuario.current;

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
      try {
        const response = await axios.delete(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          success("Período exclúido com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        } else {
          error("Algo deu errado!");
        }
      } catch (error) {
        error("Algo deu errado!");
      }
    } else {
      document.location.href = "/";
    }
  };

  const delegarPeriodos = async () => {
    setOpenDelegar(false);

    const Token = validateToken();

    if (Token) {
      const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;

      let periodoUsuario1Fracao = 0;
      let periodoUsuario2Fracao = 0;
      let formDataPrincipal = {};
      let formData1 = {};
      let formData2 = {};
      let temFracoes = false;
      try {
        const responsePEUFrac = await axios.get(URLPEUFrac, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responsePEUFrac.data.length > 0) {
          temFracoes = true;
          responsePEUFrac.data.filter(async (p: any) => {
            p.key = p.id;
            if (periodoUsuario1Fracao === 0) {
              periodoUsuario1Fracao = p.id;
            } else {
              periodoUsuario2Fracao = p.id;
            }
          });

          formData1 = {
            status: "DELEGADO",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario1Fracao,
          };
          formData2 = {
            status: "DELEGADO",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario2Fracao,
          };
          formDataPrincipal = {
            status: "DELEGADO",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        } else {
          formDataPrincipal = {
            status: "DELEGADO",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        }
        const result1 = atualizarPeriodoUsuario(formDataPrincipal);

        if ((await result1) === 1) {
          if (temFracoes) {
            const result2 = atualizarPeriodoUsuario(formData1);

            if ((await result2) === 1) {
              const result3 = atualizarPeriodoUsuario(formData2);
              if ((await result3) === 1) {
                let formDataEmail = {
                  tipoEmail: 18,
                  periodoUsuarioId: periodoUsuario.current,
                  valorPrincipal: 11,
                  valor1Fracao: 0,
                  valor2Fracao: 0,
                };
                let resultEmail = enviarEmail(formDataEmail);
                if (await resultEmail) {
                  successLongaDuracao(
                    'Períodos atualizados com sucesso! Caso queira voltar atrás basta clicar em "Delegar" novamente.'
                  );
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else {
                  error(
                    "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
                  );
                }
              } else {
                error("Não foi possível atualizar o segundo período.");
              }
            } else {
              error("Não foi possível atualizar o primeiro período.");
            }
          } else {
            let formDataEmail = {
              tipoEmail: 18,
              periodoUsuarioId: periodoUsuario.current,
              valorPrincipal: 11,
              valor1Fracao: 0,
              valor2Fracao: 0,
            };
            let resultEmail = enviarEmail(formDataEmail);
            if (await resultEmail) {
              successLongaDuracao(
                'Período atualizado com sucesso! Caso queira voltar atrás basta clicar em "Delegar" novamente.'
              );
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error(
                "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
              );
            }
          }
        } else {
          error("Não foi possível atualizar o período principal.");
        }
      } catch (error) {
        error("Há algo de errado!");
      }
    } else {
      document.location.href = "/login";
    }
  };
  const retirarDelegarPeriodos = async () => {};
  const naoPertubePeriodos = async () => {
    setOpenNaoPertube(false);

    const Token = validateToken();

    if (Token) {
      const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;

      let periodoUsuario1Fracao = 0;
      let periodoUsuario2Fracao = 0;
      let formDataPrincipal = {};
      let formData1 = {};
      let formData2 = {};
      let temFracoes = false;
      try {
        const responsePEUFrac = await axios.get(URLPEUFrac, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responsePEUFrac.data.length > 0) {
          temFracoes = true;
          responsePEUFrac.data.filter(async (p: any) => {
            p.key = p.id;
            if (periodoUsuario1Fracao === 0) {
              periodoUsuario1Fracao = p.id;
            } else {
              periodoUsuario2Fracao = p.id;
            }
          });
          formData1 = {
            status: "NAO_PERTUBE",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario1Fracao,
          };
          formData2 = {
            status: "NAO_PERTUBE",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario2Fracao,
          };
          formDataPrincipal = {
            status: "NAO_PERTUBE",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        } else {
          formDataPrincipal = {
            status: "NAO_PERTUBE",
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        }
        const result1 = atualizarPeriodoUsuario(formDataPrincipal);

        if ((await result1) === 1) {
          if (temFracoes) {
            const result2 = atualizarPeriodoUsuario(formData1);

            if ((await result2) === 1) {
              const result3 = atualizarPeriodoUsuario(formData2);
              if ((await result3) === 1) {
                let formDataEmail = {
                  tipoEmail: 18,
                  periodoUsuarioId: periodoUsuario.current,
                  valorPrincipal: 13,
                  valor1Fracao: 0,
                  valor2Fracao: 0,
                };
                let resultEmail = enviarEmail(formDataEmail);
                if (await resultEmail) {
                  successLongaDuracao(
                    'Períodos atualizados com sucesso! Caso queira voltar atrás, clique em "Não pertube" novamente.'
                  );
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else {
                  error(
                    "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
                  );
                }
              } else {
                error("Não foi possível atualizar o segundo período.");
              }
            } else {
              error("Não foi possível atualizar o primeiro período.");
            }
          } else {
            let formDataEmail = {
              tipoEmail: 18,
              periodoUsuarioId: periodoUsuario.current,
              valorPrincipal: 13,
              valor1Fracao: 0,
              valor2Fracao: 0,
            };
            let resultEmail = enviarEmail(formDataEmail);
            if (await resultEmail) {
              successLongaDuracao(
                'Período atualizado com sucesso! Caso queira voltar atrás, clique em "Não pertube" novamente.'
              );
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error(
                "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
              );
            }
          }
        } else {
          error("Não foi possível atualizar o período principal.");
        }
      } catch (error) {
        error("Há algo de errado!");
      }
    } else {
      document.location.href = "/login";
    }
  };
  const retirarNaoPertubePeriodos = async () => {
    setOpenRetirarNaoPertube(false);

    const Token = validateToken();

    if (Token) {
      const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${periodoUsuario.current}`;

      let periodoUsuario1Fracao = 0;
      let periodoUsuario2Fracao = 0;
      let formDataPrincipal = {};
      let formData1 = {};
      let formData2 = {};
      let temFracoes = false;
      try {
        const responsePEUFrac = await axios.get(URLPEUFrac, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responsePEUFrac.data.length > 0) {
          temFracoes = true;
          responsePEUFrac.data.filter(async (p: any) => {
            p.key = p.id;
            if (periodoUsuario1Fracao === 0) {
              periodoUsuario1Fracao = p.id;
            } else {
              periodoUsuario2Fracao = p.id;
            }
          });
          formData1 = {
            status:
              statusAnterior.current === "NAO_PERTUBE"
                ? "SEM_STATUS"
                : statusAnterior.current,
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario1Fracao,
          };
          formData2 = {
            status:
              statusAnterior.current === "NAO_PERTUBE"
                ? "SEM_STATUS"
                : statusAnterior.current,
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario2Fracao,
          };
          formDataPrincipal = {
            status:
              statusAnterior.current === "NAO_PERTUBE"
                ? "SEM_STATUS"
                : statusAnterior.current,
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        } else {
          formDataPrincipal = {
            status:
              statusAnterior.current === "NAO_PERTUBE"
                ? "SEM_STATUS"
                : statusAnterior.current,
            statusAnterior: statusAtual.current,

            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        }
        const result1 = atualizarPeriodoUsuario(formDataPrincipal);

        if ((await result1) === 1) {
          if (temFracoes) {
            const result2 = atualizarPeriodoUsuario(formData1);

            if ((await result2) === 1) {
              const result3 = atualizarPeriodoUsuario(formData2);

              if ((await result3) === 1) {
                let formDataEmail = {
                  tipoEmail: 18,
                  periodoUsuarioId: periodoUsuario.current,
                  valorPrincipal: 14,
                  valor1Fracao: 0,
                  valor2Fracao: 0,
                };
                let resultEmail = enviarEmail(formDataEmail);
                if (await resultEmail) {
                  successLongaDuracao("Períodos atualizados com sucesso!");
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                } else {
                  error(
                    "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
                  );
                }
              } else {
                error("Não foi possível atualizar o segundo período.");
              }
            } else {
              error("Não foi possível atualizar o primeiro período.");
            }
          } else {
            let formDataEmail = {
              tipoEmail: 18,
              periodoUsuarioId: periodoUsuario.current,
              valorPrincipal: 14,
              valor1Fracao: 0,
              valor2Fracao: 0,
            };
            let resultEmail = enviarEmail(formDataEmail);
            if (await resultEmail) {
              successLongaDuracao("Período atualizado com sucesso!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error(
                "Não foi possível enviar e-mail de comprovação da ação. Favor entrar em contato conosco."
              );
            }
          }
        } else {
          error("Não foi possível atualizar o período principal.");
        }
      } catch (error) {
        error("Há algo de errado!");
      }
    } else {
      document.location.href = "/login";
    }
  };

  const alterarPeriodosDivulgados = () => {
    setOpenAlterandoDivulgado(false);
    const Token = validateToken();

    if (excluindoFracionados.current === true) {
      setOpenExcluirFracionados(true);
    } else {
      if (reservandoOuUtilizandoOuTrocando.current === "utilizando") {
        Utilizar(Token, periodoUsuario.current);
      } else {
        if (reservandoOuUtilizandoOuTrocando.current === "trocando") {
          Trocar(Token, periodoUsuario.current);
        } else {
          if (reservandoOuUtilizandoOuTrocando.current === "reservando") {
            Reservar(Token, periodoUsuario.current);
          } else {
            if (fracionando.current) {
              setOpenModalPerguntaFracaoCompleta(true);
            } else {
              AbrirModalValor();
            }
          }
        }
      }
    }
  };

  const handleFilter = () => {
    localStorage.removeItem("filtrosDispPeriodo");
    localStorage.removeItem("pageDispPeriodo");
    setSemFiltros(true);
    document.location.reload();
  };

  const excluirFracionadosAtualizando = () => {
    excluirFracionados(reservandoOuUtilizandoOuTrocando.current);
  };

  const excluirFracionados = async (tipo: string) => {
    setOpenExcluirFracionados(false);
    const Token = validateToken();
    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuario.current);

    if (Token) {
      let formDataPrincipal = {};
      let formData1 = {};
      let formData2 = {};
      const Token = validateToken();
      let periodoUsuario1Fracao = 0;
      let periodoUsuario2Fracao = 0;
      let situacaoAnterior1;
      let situacaoAnterior2;

      let situacaoAnteriorPrincipal;

      switch (situacao.current) {
        case "Alugar":
          situacaoAnterior.current = "ALUGAR";
          break;
        case "Alugar ou trocar":
          situacaoAnterior.current = "ALUGAR_TROCAR";
          break;
        case "Trocar":
          situacaoAnterior.current = "TROCAR";
          break;
        case "Não definido":
          situacaoAnterior.current = "SEM_STATUS";
          break;
        case "Reservado pelo próprio":
          situacaoAnterior.current = "CONCLUIDO_PELO_PROPRIO";
          break;
        case "Será utilizado":
          situacaoAnterior.current = "UTILIZADO";
          break;
      }

      disponibilizarPeriodo.filter(async (p: any) => {
        if (p.id === periodoUsuario.current) {
          if (await p.children) {
            p.children.filter(async (q: any) => {
              if ((await q.fracionamento) === (await p.id)) {
                if (periodoUsuario1Fracao === 0) {
                  periodoUsuario1Fracao = q.id;
                  situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                } else {
                  periodoUsuario2Fracao = q.id;
                  situacaoAnterior2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                }
              }
            });
          }
        }
      });

      if (await divulgando) {
        if (reservandoOuUtilizandoOuTrocando.current === "utilizando") {
          formDataPrincipal = {
            alugar: 0,
            trocar: 0,
            utilizar: 1,
            concluido: 0,
            status: "ALTERANDO",
            statusAnterior: "NAO_FRACIONE",
            situacaoAnterior: situacaoAnterior.current,
            caso: 2,
            periodoUsuario: periodoUsuario.current,
          };
        } else {
          if (reservandoOuUtilizandoOuTrocando.current === "reservando") {
            formDataPrincipal = {
              alugar: 0,
              trocar: 0,
              concluido: 1,
              utilizar: 0,
              status: "ALTERANDO",
              statusAnterior: "NAO_FRACIONE",
              situacaoAnterior: situacaoAnterior.current,
              caso: 2,
              periodoUsuario: periodoUsuario.current,
            };
          } else {
            if (reservandoOuUtilizandoOuTrocando.current === "trocando") {
              formDataPrincipal = {
                alugar: 0,
                trocar: 1,
                concluido: 0,
                utilizar: 0,
                status: "ALTERANDO",
                statusAnterior: "NAO_FRACIONE",
                situacaoAnterior: situacaoAnterior.current,
                caso: 2,
                periodoUsuario: periodoUsuario.current,
              };
            }
          }
        }

        if (tipo !== "apenasExcluindoFracao") {
          formData1 = {
            status: "ALTERANDO",
            statusAnterior: "NAO_FRACIONE",
            situacaoAnterior: situacaoAnterior1,

            caso: 2,
            periodoUsuario: periodoUsuario1Fracao,
          };
          formData2 = {
            status: "ALTERANDO",
            statusAnterior: "NAO_FRACIONE",
            situacaoAnterior: situacaoAnterior2,

            caso: 2,
            periodoUsuario: periodoUsuario2Fracao,
          };
        } else {
          if (tipo === "apenasExcluindoFracao") {
            formDataPrincipal = {
              status: "ALTERANDO",
              statusAnterior: "NAO_FRACIONE",
              situacaoAnterior: situacaoAnterior.current,
              caso: 2,
              periodoUsuario: periodoUsuario.current,
            };
            formData1 = {
              status: "ALTERANDO",
              statusAnterior: "NAO_FRACIONE",
              situacaoAnterior: situacaoAnterior1,

              caso: 2,
              periodoUsuario: periodoUsuario1Fracao,
            };
            formData2 = {
              status: "ALTERANDO",
              statusAnterior: "NAO_FRACIONE",
              situacaoAnterior: situacaoAnterior2,

              caso: 2,
              periodoUsuario: periodoUsuario2Fracao,
            };
          }
        }

        if ((await atualizarPeriodoUsuario(formDataPrincipal)) === 1) {
          if ((await atualizarPeriodoUsuario(formData1)) === 1) {
            if (await atualizarPeriodoUsuario(formData2)) {
              success("Período atualizado com sucesso!");
              setTimeout(() => {
                //document.location.reload();
              }, 2000);
            } else {
              error("Não foi possível atualizar a segunda fração");
            }
          } else {
            error("Não foi possível atualizar a primeira fração.");
          }
        } else {
          error("Não foi possível atualizar período principal");
        }
      } else {
        if (tipo !== "apenasExcluindoFracao") {
          if (reservandoOuUtilizandoOuTrocando.current === "utilizando") {
            Utilizar(Token, periodoUsuario.current);
          } else {
            if (reservandoOuUtilizandoOuTrocando.current === "reservando") {
              //Reservar(Token, periodoUsuario.current);
              console.log("periodo", periodoUsuario.current);

              setOpenModalReserva(true);
            } else {
              if (reservandoOuUtilizandoOuTrocando.current === "trocando") {
                Trocar(Token, periodoUsuario.current);
              }
            }
          }
        }
        let result1 = deletarPeriodoUsuario(periodoUsuario1Fracao, true);
        if ((await result1) === 1) {
          let result2 = deletarPeriodoUsuario(periodoUsuario2Fracao, true);
          if ((await result2) === 1) {
            if (tipo !== "apenasExcluindoFracao") {
              return 1;
            } else {
              success("Períodos atualizados com sucesso!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            }
          }
        }
      }
    } else {
      document.location.href = "/login";
    }
  };

  // const excluirFracionados = async (tipo: string) => {
  //   setOpenExcluirFracionados(false);
  //   const Token = validateToken();
  //   if (!Token) return (document.location.href = "/login");

  //   const divulgando = await verificarSeTemPeriodoDivulgado(
  //     periodoUsuario.current
  //   );
  //   definirSituacaoAnterior(situacao.current);

  //   const {
  //     periodoUsuario1Fracao,
  //     periodoUsuario2Fracao,
  //     situacaoAnterior1,
  //     situacaoAnterior2,
  //   } = await obterFracoes(periodoUsuario.current);

  //   const formDataPrincipal = gerarFormDataPrincipal(
  //     tipo,
  //     periodoUsuario.current,
  //     situacaoAnterior.current
  //   );
  //   const formData1 = gerarFormDataFracao(
  //     periodoUsuario1Fracao,
  //     situacaoAnterior1
  //   );
  //   const formData2 = gerarFormDataFracao(
  //     periodoUsuario2Fracao,
  //     situacaoAnterior2
  //   );

  //   if (divulgando) {
  //     const sucesso =
  //       (await atualizarPeriodoUsuario(formDataPrincipal)) === 1 &&
  //       (await atualizarPeriodoUsuario(formData1)) === 1 &&
  //       (await atualizarPeriodoUsuario(formData2));

  //     if (sucesso) {
  //       success("Período atualizado com sucesso!");
  //       setTimeout(() => {}, 2000);
  //     } else {
  //       error("Erro ao atualizar os períodos.");
  //     }
  //   } else {
  //     await tratarNaoDivulgado(
  //       tipo,
  //       Token,
  //       periodoUsuario.current,
  //       periodoUsuario1Fracao,
  //       periodoUsuario2Fracao,
  //       situacaoAnterior.current
  //     );
  //   }
  // };

  // const definirSituacaoAnterior = (situacao: string) => {
  //   const mapaSituacoes: Record<string, string> = {
  //     Alugar: "ALUGAR",
  //     "Alugar ou trocar": "ALUGAR_TROCAR",
  //     Trocar: "TROCAR",
  //     "Não definido": "SEM_STATUS",
  //     "Reservado pelo próprio": "CONCLUIDO_PELO_PROPRIO",
  //     "Será utilizado": "UTILIZADO",
  //   };
  //   situacaoAnterior.current = mapaSituacoes[situacao] || "SEM_STATUS";
  // };

  // const obterFracoes = async (periodoId: number) => {
  //   let fracao1 = 0,
  //     fracao2 = 0;
  //   let situacao1, situacao2;

  //   for (const p of disponibilizarPeriodo) {
  //     if (p.id === periodoId && p.children) {
  //       for (const q of p.children) {
  //         if (q.fracionamento === p.id) {
  //           if (fracao1 === 0) {
  //             fracao1 = q.id;
  //             situacao1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
  //           } else {
  //             fracao2 = q.id;
  //             situacao2 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
  //           }
  //         }
  //       }
  //     }
  //   }

  //   return {
  //     periodoUsuario1Fracao: fracao1,
  //     periodoUsuario2Fracao: fracao2,
  //     situacaoAnterior1: situacao1,
  //     situacaoAnterior2: situacao2,
  //   };
  // };

  // const gerarFormDataPrincipal = (
  //   tipo: string,
  //   periodoId: number,
  //   situacaoAnterior: string
  // ) => {
  //   const status = "ALTERANDO";
  //   const statusAnterior = "NAO_FRACIONE";
  //   const caso = 2;

  //   if (tipo === "apenasExcluindoFracao") {
  //     return {
  //       status,
  //       statusAnterior,
  //       situacaoAnterior,
  //       caso,
  //       periodoUsuario: periodoId,
  //     };
  //   }

  //   const mapStatus = {
  //     utilizando: { alugar: 0, trocar: 0, utilizar: 1, concluido: 0 },
  //     reservando: { alugar: 0, trocar: 0, utilizar: 0, concluido: 1 },
  //     trocando: { alugar: 0, trocar: 1, utilizar: 0, concluido: 0 },
  //   };

  //   const tipoAtual =
  //     reservandoOuUtilizandoOuTrocando.current as keyof typeof mapStatus;

  //   return {
  //     ...mapStatus[tipoAtual],
  //     status,
  //     statusAnterior,
  //     situacaoAnterior,
  //     caso,
  //     periodoUsuario: periodoId,
  //   };
  // };

  // const gerarFormDataFracao = (periodoId: number, situacaoAnterior: any) => ({
  //   status: "ALTERANDO",
  //   statusAnterior: "NAO_FRACIONE",
  //   situacaoAnterior,
  //   caso: 2,
  //   periodoUsuario: periodoId,
  // });

  // const tratarNaoDivulgado = async (
  //   tipo: string,
  //   token: any,
  //   periodoId: number,
  //   fracao1: number,
  //   fracao2: number,
  //   situacaoAnterior: string
  // ) => {
  //   if (tipo !== "apenasExcluindoFracao") {
  //     const acao = reservandoOuUtilizandoOuTrocando.current;
  //     if (acao === "utilizando") return Utilizar(token, periodoId);
  //     if (acao === "reservando") return setOpenModalReserva(true);
  //     if (acao === "trocando") return Trocar(token, periodoId);
  //   }

  //   const deletou1 = (await deletarPeriodoUsuario(fracao1, true)) === 1;
  //   const deletou2 = (await deletarPeriodoUsuario(fracao2, true)) === 1;

  //   if (deletou1 && deletou2) {
  //     if (tipo === "apenasExcluindoFracao") {
  //       success("Períodos atualizados com sucesso!");
  //       setTimeout(() => document.location.reload(), 2000);
  //     } else {
  //       return 1;
  //     }
  //   }
  // };

  const onCancelFracaoCompleta = () => {
    setOpenModalFracaoCompleta(false);
  };
  const onCancelFracaoCompletaAtualizar = () => {
    atualizando.current = false;
    setOpenModalFracaoCompletaAtualizar(false);
  };
  const onRangeChangePeriodoPrincipal = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {};

  //como o que preciso é um modal informativo que você não deve ter inputs então não precisa de onChange. Veja um exemplo de modal
  const CollectionCreateFormFracaoCompleta: React.FC<
    CollectionCreateFormPropsFracaoCompleta
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openModalFracaoCompleta}
        title="Alugar período e fracionados"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancelFracaoCompleta}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              //console.log(values); // Aqui estão os valores do form
              form.resetFields();
              onCreate(values); // Se quiser usar esses valores pra algo
            })
            .catch((errorInfo) => {
              console.log("Validate Failed:", errorInfo);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onKeyUp={handleKeyPressFracaoCompleta}
          onChange={(valuesFracaoCompleta) => {
            onChangeFormFracaoCompleta(valuesFracaoCompleta);
          }}

          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo_pai"
                label="Período principal"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePeriodoPrincipal}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMinPrincipal"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema1Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema2Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          {/* <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio value={"AGUARDANDO_SUGESTAO"}>Sugestão</Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group> */}
        </Form>
      </Modal>
    );
  };
  const CollectionCreateFormFracaoCompletaAtualizar: React.FC<
    CollectionCreateFormPropsFracaoCompletaAtualizar
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openModalFracaoCompletaAtualizar}
        title="Alugar período e fracionados"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancelFracaoCompletaAtualizar}
        onOk={() => {
          form
            .validateFields()
            .then((valuesFracaoCompletaAtualizar) => {
              form.resetFields();
              onCreate(valuesFracaoCompletaAtualizar);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onKeyUp={handleKeyPressFracaoCompleta}
          onChange={(valuesFracaoCompletaAtualizar) => {
            onChangeFormFracaoCompleta(valuesFracaoCompletaAtualizar);
          }}
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo_pai"
                label="Período principal"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePeriodoPrincipal}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMinPrincipal"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema1Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[true, true]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="valorSugerido" label="Sugestão">
                {valorSugeridoSistema2Fracao.current}
              </Form.Item>
            </Col>
          </Row>
          {/* <Radio.Group onChange={onChangeStatus} value={valueStatus}>
            <Radio value={"AGUARDANDO_SUGESTAO"}>Sugestão</Radio>
            <Radio value={"AGUARDANDO_PEDIDO"}>A Pedido</Radio>
          </Radio.Group> */}
        </Form>
      </Modal>
    );
  };

  const retornaStatusSeValorDesatualizado = (
    valorMin: string,
    valorSugerido: string
  ) => {
    let valorMinNovo = parseFloat(valorMin.replace(".", "").replace(",", "."));
    let valorSugeridoNovo = parseFloat(
      valorSugerido?.replace(".", "").replace(",", ".")
    );

    if (valorMinNovo > valorSugeridoNovo) {
      return "VALOR_ALTO";
    } else {
      return "SEM_STATUS";
    }
  };

  const hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });

  useEffect(() => {
    const fetch = async () => {
      const Token = validateToken();

      let obj = localStorage.getItem("filtrosDispPeriodo");
      let page = localStorage.getItem("pageDispPeriodo");
      if (obj) {
        let novoFiltro = JSON.parse(obj);
        setFilteredInfo({
          checkIn: novoFiltro.checkIn,
          checkOut: novoFiltro.checkOut,
          especial: novoFiltro.especial,
          situacao: novoFiltro.situacao,

          status: novoFiltro.status,
        });
        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token && nCotaUsuarioId.cotaUsuarioId) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${nCotaUsuarioId.cotaUsuarioId}`;

        const URLDetalhesEmpreend = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/${nCotaUsuarioId.cotaUsuarioId}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          const responseDetalhesEmpreend = await axios.get(
            URLDetalhesEmpreend,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );

          if (response && responseDetalhesEmpreend) {
            nomeEmpreend.current =
              responseDetalhesEmpreend.data.CotaTable.AptoTable.EmpreendimentoTable.nome;
            numeroApto.current = responseDetalhesEmpreend.data.numeroApto;

            setCotaId(responseDetalhesEmpreend.data.CotaTable.id);
            switch (
              responseDetalhesEmpreend.data.CotaTable.AptoTable
                .EmpreendimentoTable.origem
            ) {
              case 0:
                switch (
                  responseDetalhesEmpreend.data.CotaTable.AptoTable
                    .EmpreendimentoTable.cronograma
                ) {
                  case 0:
                    if (response.data.length === 0) {
                      if (
                        responseDetalhesEmpreend.data.CotaTable.AptoTable
                          .origem === 0
                      ) {
                        alert(
                          "Você ainda não informou seus períodos. Favor informar."
                        );
                        document.location.href = `/adicionarPeriodos/?cotaUsuarioId=${nCotaUsuarioId.cotaUsuarioId}`;
                      } else {
                        alert(
                          'Você ainda não informou seus períodos. Favor clicar em "+ Período" para informar. '
                        );
                      }
                    }
                    break;
                  case 1:
                    if (
                      responseDetalhesEmpreend.data.CotaTable.AptoTable
                        .origem === 0
                    ) {
                      const result = acertoPeriodosProprietario(
                        +Token.id,
                        nCotaUsuarioId.cotaUsuarioId
                      );

                      if ((await result) === 1) {
                        alert(
                          "Novos períodos foram adicionados. Caso queira, você já pode decidir o que fazer com eles. Quanto antes melhor!"
                        );
                        document.location.reload();
                      }
                    } else {
                      if (response.data.length === 0) {
                        alert(
                          'Você ainda não informou seus períodos. Favor clicar em "+ Período" para informar. '
                        );
                      }
                    }

                    break;
                  case 2:
                    if (response.data.length === 0) {
                      alert(
                        "Você ainda não informou seus períodos. Favor informar."
                      );
                      // document.location.href = `/adicionarPeriodos/?cotaUsuarioId=${nCotaUsuarioId.cotaUsuarioId}`;
                    }
                    break;
                }
                break;
              default:
                if (response.data.length === 0) {
                  alert(
                    'Você ainda não informou seus períodos. Favor clicar em "+ Período" para informar. '
                  );
                }
                break;
            }

            let ArrayNovo = response.data.filter(async (p: any) => {
              if (p.active === 0) {
                return null;
              } else {
                if (p.fracionamento === 0) {
                  p.key = p.id;

                  p.periodoId = p.PeriodoTable.id;

                  p.periodoUsuarioId = p.id;

                  p.valorSugeridoInicial = p.PeriodoTable.valor;

                  p.checkIn = formatarData(p.PeriodoTable.checkIn);

                  p.checkOut = formatarData(p.PeriodoTable.checkOut);

                  if (p.PeriodoTable.valor) {
                    p.valorSugeridoSistema = await retornarValorAtualizado(
                      p.PeriodoTable.valor,
                      p.checkIn,
                      p.checkOut,

                      3
                    );
                  }
                  if (
                    p.valorMin &&
                    p.valorSugeridoSistema &&
                    p.status !== "ALTERANDO" &&
                    p.status !== "DELEGADO" &&
                    p.status !== "NAO_PERTUBE"
                  ) {
                    const resultado = await retornaStatusSeValorDesatualizado(
                      p.valorMin,
                      p.valorSugeridoSistema
                    );
                    if (resultado === "VALOR_ALTO") {
                      p.status = "VALOR_ALTO";
                    }
                  }
                  if (p.PeriodoTable.valor === "") {
                    p.valorSugeridoSistema = "";
                  }
                  return p;
                } else {
                  return null;
                }
              }
            });

            ArrayNovo = response.data.filter((p: any) => {
              if (p.active === 0) {
                return null;
              } else {
                if (p.fracionamento === 0) {
                  //ajustes dos nomes
                  p.situacao === "NAO_DEFINIDO"
                    ? (p.situacao = "Não definido")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "NAO_DEFINIDO"
                    ? (p.situacaoAnterior = "Não definido")
                    : (p.situacaoAnterior = p.situacaoAnterior);
                  p.situacao === "ALUGAR"
                    ? (p.situacao = "Alugar")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "Alugar"
                    ? (p.situacaoAnterior = "Alugar")
                    : (p.situacaoAnterior = p.situacaoAnterior);
                  p.situacao === "ALUGAR_TROCAR"
                    ? (p.situacao = "Alugar ou trocar")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "ALUGAR_TROCAR"
                    ? (p.situacaoAnterior = "Alugar ou trocar")
                    : (p.situacaoAnterior = p.situacaoAnterior);
                  p.situacao === "TROCAR"
                    ? (p.situacao = "Trocar")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "TROCAR"
                    ? (p.situacaoAnterior = "Trocar")
                    : (p.situacaoAnterior = p.situacaoAnterior);
                  p.situacao === "UTILIZADO"
                    ? (p.situacao = "Será utilizado")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "UTILIZADO"
                    ? (p.situacaoAnterior = "Será utilizado")
                    : (p.situacaoAnterior = p.situacaoAnterior);
                  p.situacao === "CONCLUIDO_PELO_PROPRIO"
                    ? (p.situacao = "Reservado pelo próprio")
                    : (p.situacao = p.situacao);
                  p.situacaoAnterior === "CONCLUIDO_PELO_PROPRIO"
                    ? (p.situacaoAnterior = "Reservado pelo próprio")
                    : (p.situacaoAnterior = p.situacaoAnterior);

                  p.key = p.id;
                  p.periodoId = p.PeriodoTable.id;
                  p.periodoUsuarioId = p.id;
                  p.checkIn = formatarData(p.PeriodoTable.checkIn);
                  p.checkOut = formatarData(p.PeriodoTable.checkOut);
                  if (validateDataCheckOutMaior(p.checkOut, hoje)) {
                    if (p.status !== "FINALIZADO" && p.status !== "ALTERANDO") {
                      let formData = {
                        status: "FINALIZADO",
                        periodoUsuario: p.id,
                        caso: 1,
                      };

                      atualizarPeriodoUsuario(formData);
                      p.status = "FINALIZADO";
                    } else {
                      if (p.concluido === 3) {
                        p.situacao = "Períodos fracionados reservados";
                        let formData = {
                          status: "FINALIZADO",
                          periodoUsuario:
                            nCotaUsuarioId.cotaUsuarioId === 0 ? p.idPEU : p.id,
                          caso: 1,
                        };
                        atualizarPeriodoUsuario(formData);
                        p.valorMin = "";
                      } else {
                        if (p.concluido === 2) {
                          p.situacao = "Reservado por MC";
                          p.valorMin = exibirMoeda(p.valorMin);
                          p.valorSugerido = "";
                        } else {
                          if (p.concluido === 1) {
                            p.situacao = "Reservado pelo próprio";
                            p.valorMin = exibirMoeda(p.valorMin);
                            // p.valorSugerido = exibirMoeda(p.valorSugerido);
                          } else {
                            if (p.utilizar === 1) {
                              p.situacao = "Será utilizado";
                              p.valorMin = "";
                              p.valorSugerido = "";
                            } else {
                              if (p.alugar === 1 && p.trocar === 1) {
                                p.situacao = "Alugar ou trocar";
                                p.valorMin = exibirMoeda(p.valorMin);
                              } else {
                                if (p.alugar === 0 && p.trocar === 1) {
                                  p.situacao = "Trocar";
                                  p.valorMin = "";
                                  p.valorSugerido = "";
                                } else {
                                  if (p.alugar === 1 && p.trocar === 0) {
                                    p.situacao = "Alugar";
                                    p.valorMin = exibirMoeda(p.valorMin);
                                  } else {
                                    p.situacao = "Não definido";
                                    p.valorMin = "";
                                    p.valorSugerido = "";
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    if (p.status === "FRACAO_FINALIZADA") {
                      p.situacao = "Alugado ou utilizado parcialmente";
                      p.valorMin = "";
                      p.valorSugeridoSistema = "";
                      p.status = "FINALIZADO";
                    } else {
                      if (p.concluido === 3) {
                        p.situacao = "Períodos fracionados reservados";

                        p.valorMin = "";
                        p.valorSugeridoSistema = "";
                        if (p.status !== "ALTERANDO") {
                          p.status = "FINALIZADO";
                        }
                      } else {
                        if (p.concluido === 2) {
                          p.situacao = "Reservado por MC";
                          p.valorMin = exibirMoeda(p.valorMin);
                          p.valorSugeridoSistema = "";

                          p.valorSugeridoSistema = "";
                          if (p.status !== "ALTERANDO") {
                            let formData = {
                              status: "FINALIZADO",
                              periodoUsuario: p.id,
                              caso: 1,
                            };
                            p.status = "FINALIZADO";

                            atualizarPeriodoUsuario(formData);
                          }
                        } else {
                          if (p.concluido === 1) {
                            p.valorMin = exibirMoeda(p.valorMin);
                            p.valorSugeridoSistema = "";
                            if (p.status !== "ALTERANDO") {
                              p.situacao = "Reservado pelo próprio";
                              let formData = {
                                status: "FINALIZADO",
                                periodoUsuario: p.id,
                                caso: 1,
                              };
                              p.status = "FINALIZADO";

                              atualizarPeriodoUsuario(formData);
                            }
                          } else {
                            if (p.utilizar === 1) {
                              p.situacao = "Será utilizado";

                              if (p.status !== "ALTERANDO") {
                                let formData = {
                                  status: "FINALIZADO",
                                  periodoUsuario: p.id,
                                  caso: 1,
                                };
                                p.status = "FINALIZADO";
                                p.valorMin = "";
                                p.valorSugeridoSistema = "";

                                atualizarPeriodoUsuario(formData);
                              } else {
                                p.valorMin = exibirMoeda(p.valorMin);
                              }
                            } else {
                              if (p.alugar === 1 && p.trocar === 1) {
                                p.situacao = "Alugar ou trocar";

                                p.valorMin = exibirMoeda(p.valorMin);
                              } else {
                                if (p.alugar === 1 && p.trocar === 0) {
                                  p.situacao = "Alugar";
                                  p.valorMin = exibirMoeda(p.valorMin);
                                } else {
                                  if (p.alugar === 0 && p.trocar === 1) {
                                    p.situacao = "Trocar";
                                    if (p.status !== "ALTERANDO") {
                                      p.valorMin = "";
                                      p.valorSugeridoSistema = "";
                                    } else {
                                      p.valorMin = exibirMoeda(p.valorMin);
                                      p.valorSugeridoSistema = "";
                                    }
                                  } else {
                                    p.situacao = "Não definido";
                                    p.valorMin = "";
                                    if (p.status !== "DELEGADO") {
                                      p.status = "SEM_STATUS";
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }

                  if (p.status === "ALTERANDO") {
                    if (p.situacaoAnterior === "ALUGAR") {
                      p.situacao = "Alugar";
                    } else {
                      if (p.situacaoAnterior === "ALUGAR_TROCAR") {
                        p.situacao = "Alugar ou trocar";
                      }
                    }
                  } else {
                    if (
                      p.status === "AGUARDANDO_SUGESTAO" ||
                      p.status === "AGUARDANDO_PEDIDO" ||
                      p.status === "REJEITADO" ||
                      p.status === "NAO_FRACIONE"
                    ) {
                      p.status = "SEM_STATUS";
                      p.situacao = p.situacaoAnterior;
                    } else {
                    }
                  }
                  if (p.divulgado === 0) {
                    p.divulgado = "Não";
                  } else {
                    p.divulgado = "Sim";
                  }
                  if (
                    p.PeriodoTable.dataEspecial === null ||
                    p.PeriodoTable.dataEspecial === ""
                  ) {
                    p.especial = "Data_normal";
                  } else {
                    p.especial = "Data_especial";
                  }

                  p.PeriodoTable.dataEspecial === null
                    ? (p.dataEspecial = "Data normal")
                    : (p.dataEspecial = p.PeriodoTable.dataEspecial);

                  p.created_at = formatarData(p.created_at);

                  if (p.valorSugeridoSistema === "0") {
                    p.valorSugeridoSistema = "";
                  }

                  let contadorUtilizado = 0;
                  let contadorTrocar = 0;
                  let contadorReservados = 0;
                  let ArrayChildren = response.data.filter(async (q: any) => {
                    if (q.fracionamento === p.id && q.active !== 0) {
                      q.key = q.id;
                      q.checkIn = formatarData(q.PeriodoTable.checkIn);
                      q.checkOut = formatarData(q.PeriodoTable.checkOut);
                      let valorSugeridoSistema = await retornarValorAtualizado(
                        p.PeriodoTable.valor,
                        p.checkIn,
                        p.checkOut,
                        3
                      );

                      q.valorSugeridoSistema = await retornarValorAtualizado(
                        valorSugeridoSistema,
                        q.checkIn,
                        q.checkOut,
                        3
                      );

                      if (
                        q.valorMin &&
                        q.valorSugeridoSistema &&
                        q.status !== "ALTERANDO" &&
                        q.status !== "DELEGADO" &&
                        q.status !== "NAO_PERTUBE" &&
                        q.situacao !== "Será utilizado" &&
                        q.situacao !== "Reservado pelo próprio" &&
                        q.situacao !== "Reservado por MC"
                      ) {
                        const resultado =
                          await retornaStatusSeValorDesatualizado(
                            q.valorMin,
                            q.valorSugeridoSistema
                          );
                        if (resultado === "VALOR_ALTO") {
                          q.status = "VALOR_ALTO";
                        }
                      }

                      return q;
                    } else {
                      return null;
                    }
                  });

                  ArrayChildren = response.data.filter((q: any) => {
                    if (q.fracionamento === p.id && q.active !== 0) {
                      q.key = q.id;
                      q.periodoId = q.PeriodoTable.id;
                      q.periodoUsuarioId = q.id;
                      if (
                        p.PeriodoTable.dataEspecial === null ||
                        p.PeriodoTable.dataEspecial === ""
                      ) {
                        q.especial = "Data_normal";
                        q.dataEspecial = "Data_normal";
                      } else {
                        q.especial = "Data_especial";
                        q.dataEspecial = p.dataEspecial;
                      }

                      if (q.concluido === 2) {
                        q.situacao = "Reservado por MC";
                        q.valorMin = exibirMoeda(q.valorMin);
                        contadorReservados++;
                        q.status = "FINALIZADO";
                        let formData = {
                          status: "FINALIZADO",
                          periodoUsuario: q.id,
                          caso: 1,
                        };
                        q.status = "FINALIZADO";

                        atualizarPeriodoUsuario(formData);

                        q.valorSugeridoSistema = "";
                        if (
                          q.status !== "FINALIZADO" &&
                          q.status !== "ALTERANDO"
                        ) {
                          let formData = {
                            status: "FINALIZADO",
                            periodoUsuario: q.id,
                          };
                          atualizarPeriodoUsuario(formData);
                          q.status = "FINALIZADO";
                        }
                      } else {
                        if (q.concluido === 1) {
                          q.valorMin = exibirMoeda(q.valorMin);

                          if (q.status !== "ALTERANDO") {
                            q.situacao = "Reservado pelo próprio";
                            contadorReservados++;
                          }

                          q.valorSugeridoSistema = "";
                          if (
                            q.status !== "FINALIZADO" &&
                            q.status !== "ALTERANDO"
                          ) {
                            q.status = "FINALIZADO";
                            let formData = {
                              status: "FINALIZADO",
                              periodoUsuario: q.id,
                              caso: 1,
                            };
                            atualizarPeriodoUsuario(formData);
                            q.status = "FINALIZADO";
                          }
                        } else {
                          if (q.utilizar === 1) {
                            q.situacao = "Será utilizado";
                            q.valorMin = exibirMoeda(q.valorMin);

                            contadorUtilizado++;

                            if (
                              q.status !== "FINALIZADO" &&
                              q.status !== "ALTERANDO"
                            ) {
                              let formData = {
                                status: "FINALIZADO",
                                periodoUsuario: q.id,
                                caso: 1,
                              };
                              atualizarPeriodoUsuario(formData);
                              q.status = "FINALIZADO";
                              q.valorMin = "";
                              q.valorSugeridoSistema = "";
                            }
                          } else {
                            if (q.alugar === 1 && q.trocar === 1) {
                              q.situacao = "Alugar ou trocar";
                              q.valorMin = exibirMoeda(q.valorMin);
                            } else {
                              if (q.alugar === 1 && q.trocar === 0) {
                                q.situacao = "Alugar";
                                q.valorMin = exibirMoeda(q.valorMin);
                              } else {
                                if (q.alugar === 0 && q.trocar === 1) {
                                  q.situacao = "Trocar";
                                  if (q.status !== "ALTERANDO") {
                                    q.valorMin = "";
                                    q.valorSugeridoSistema = "";
                                  } else {
                                    q.valorMin = exibirMoeda(q.valorMin);
                                    q.valorSugeridoSistema = "";
                                  }

                                  contadorTrocar++;
                                } else {
                                  q.situacao = "Não definido";
                                  q.valorMin = "";
                                  if (q.status === "SEM_STATUS") {
                                    q.status = "SEM_STATUS";
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      if (q.status === "ALTERANDO") {
                        if (q.situacaoAnterior === "ALUGAR") {
                          q.situacao = "Alugar";
                          q.valorSugeridoSistema = exibirMoeda(
                            q.valorSugeridoSistema
                          );
                        } else {
                          if (q.situacaoAnterior === "ALUGAR_TROCAR") {
                            q.situacao = "Alugar ou trocar";
                            q.valorSugeridoSistema = exibirMoeda(
                              q.valorSugeridoSistema
                            );
                          }
                        }
                      } else {
                        if (
                          q.status === "AGUARDANDO_SUGESTAO" ||
                          q.status === "AGUARDANDO_PEDIDO" ||
                          q.status === "REJEITADO" ||
                          q.status === "NAO_FRACIONE"
                        ) {
                          q.status = "SEM_STATUS";
                        }
                      }

                      if (q.valorSugeridoSistema === "0") {
                        q.valorSugeridoSistema = "";
                      }
                      if (q.divulgado === 0) {
                        q.divulgado = "Não";
                      } else {
                        q.divulgado = "Sim";
                      }

                      q.dataEspecial = q.PeriodoTable.dataEspecial;
                      q.created_at = formatarData(q.created_at);
                      if (p.status === "ALTERANDO") {
                        q.status = "ALTERANDO";
                      }
                      if (q.PeriodoTable.valor === null) {
                        q.valorSugeridoSistema = "";
                      }
                      if (validateDataCheckOutMaior(q.checkOut, hoje)) {
                        if (
                          q.status !== "FINALIZADO" &&
                          q.status !== "ALTERANDO"
                        ) {
                          let formData = {
                            status: "FINALIZADO",
                            periodoUsuario: q.id,
                            caso: 1,
                          };

                          atualizarPeriodoUsuario(formData);
                          q.status = "FINALIZADO";
                        }
                      }
                      return q;
                    } else {
                      return null;
                    }
                  });

                  if (ArrayChildren.length !== 0) {
                    p.children = ArrayChildren;

                    if (p.status !== "ALTERANDO") {
                      if (contadorReservados === 2) {
                        p.situacao = "Períodos fracionados reservados";
                        let formData = {
                          status: "FINALIZADO",
                          periodoUsuario: p.id,
                          caso: 1,
                        };

                        atualizarPeriodoUsuario(formData);
                        p.valorMin = "";
                        p.valorSugeridoSistema = "";
                        p.status = "FINALIZADO";
                      } else {
                        if (contadorUtilizado === 2) {
                          p.situacao = "Será utilizado";
                          let formData = {
                            status: "FINALIZADO",
                            periodoUsuario: p.id,
                            caso: 1,
                          };

                          atualizarPeriodoUsuario(formData);
                          p.valorMin = "";
                          p.valorSugeridoSistema = "";
                          p.status = "FINALIZADO";
                        } else {
                          if (contadorTrocar === 2) {
                            p.situacao = "Trocar";
                            p.valorMin = "";
                            p.valorSugeridoSistema = "";
                          } else {
                            if (
                              contadorUtilizado === 1 ||
                              contadorReservados === 1
                            ) {
                              p.situacao = "Alugado ou utilizado parcialmente";
                              p.valorMin = "";
                              p.valorSugeridoSistema = "";
                            } else {
                              if (contadorTrocar === 1) {
                                p.situacao = "Há frações com situação troca";
                                p.valorMin = "";
                                p.valorSugeridoSistema = "";
                              }
                            }
                          }
                        }
                      }
                    }
                  }

                  return p;
                } else {
                  return null;
                }
              }
            });
            setDisponibilizarPeriodo(ArrayNovo);
            setIsLoading(false);
          }
        } catch (error) {
          error("Há algo de errado.");
        }
      }
    };
    fetch();
  }, []);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (window.navigator.onLine === false) {
      setStatus(3);
      setTexto("Parece que você está sem conexão com a internet!");
      setTimeout(() => {
        setStatus(0);
      }, 3000);
    } else {
      if (!(validateDataPeriodo(periodoData.checkIn) === "ok")) {
        setStatus(3);
        setTexto(validateDataPeriodo(periodoData.checkIn));
        setTimeout(() => {
          setStatus(0);
        }, 3000);
      } else {
        if (!(validateDataPeriodo(periodoData.checkOut) === "ok")) {
          setStatus(3);
          setTexto(validateDataPeriodo(periodoData.checkOut));
          setTimeout(() => {
            setStatus(0);
          }, 3000);
        } else {
          if (periodoData.checkIn >= periodoData.checkOut) {
            setStatus(3);
            setTexto(
              "A data de check-in não pode ser maior ou igual a data de check-out."
            );
            setTimeout(() => {
              setStatus(0);
            }, 3000);
          } else {
            const Token = validateToken();
            if (Token) {
              try {
                const URL = `${Globais.DOMINIOBACK}/cota-usuario/${nCotaUsuarioId.cotaUsuarioId}`;

                const response = await axios.get(URL, {
                  headers: { Authorization: Token.AuthStr },
                });
                if (response) {
                  periodoData.cotaId = response.data.cotaId;
                  periodoData.origem = response.data.usuarioId;
                  try {
                    const URL = `${Globais.DOMINIOBACK}/periodo/`;
                    const response = await axios.post(URL, periodoData, {
                      headers: { Authorization: Token.AuthStr },
                    });

                    if (response) {
                      setStatus(1);

                      setTexto("Período incluido com sucesso!");
                      setTimeout(() => {
                        document.location.href = `/disponibilizacaoPeriodos/?cotaId=${nCotaUsuarioId.cotaUsuarioId}&&ncota=${nCotaNumero.ncota}&&empreend=${nEmpreend.empreend}`;
                      }, 3000);
                    }
                  } catch (error) {
                    switch (error.code) {
                      case "ERR_NETWORK":
                        setStatus(2);
                        setTexto(
                          "Parece que tem algo errado com nosso serviço!"
                        );
                        setTimeout(() => {
                          setStatus(0);
                        }, 3000);
                        break;
                    }
                  }
                }
              } catch (error) {
                switch (error.code) {
                  case "ERR_NETWORK":
                    setStatus(2);
                    setTexto("Parece que tem algo errado com nosso serviço!");
                    setTimeout(() => {
                      setStatus(0);
                    }, 3000);
                    break;
                }
              }
            } else {
              document.location.href = "/";
            }
          }
        }
      }
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  //------------------------------------------\\
  interface ValuesMaisPeriodo {
    checkIn: string;
    checkOut: string;
  }

  interface CollectionCreateFormPropsMaisPeriodo {
    open: boolean;
    onCreate: (valuesMaisPeriodo: ValuesMaisPeriodo) => void;
    onCancel: () => void;
  }
  const onRangeChangeMaisPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      let diferenca = CalcularDiferencaDias(
        AlterarFormatoData(dateStrings[1]),
        AlterarFormatoData(dateStrings[0])
      );
      if (diferenca > 7) {
        error("O período deve ser menor ou igual a 7 dias.");
      } else {
        checkInPeriodoAdicionado.current = dateStrings[0];
        checkOutPeriodoAdicionado.current = dateStrings[1];
      }
    }
  };
  const [openMaisPeriodo, setOpenMaisPeriodo] = useState(false);

  const dataEspecial = useRef("");
  const periodoId = periodo.current;
  const defaultPeriodoFormData = {
    cotaId: 0,
    checkIn: "",
    checkOut: "",
    dataEspecial: "",
    origem: 0,
    dias: 0,
  };

  const [cotaId, setCotaId] = useState();
  const [periodoFormData, setPeriodoFormData] = useState(
    defaultPeriodoFormData
  );

  const verificarPeriodoUsuario = async () => {
    const Token = validateToken();

    if (Token) {
      const idUser = Token.id;
      const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${idUser}/cota-usuario`;

      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data.length > 0) {
        return true; // Períodos disponíveis
      } else {
        return false; // Nenhum período disponível
      }
    } else {
      return false; // Token não é válido
    }
  };

  const criarPeriodos = async (valuesMaisPeriodo: any) => {
    const Token = validateToken();
    const verificarPeriodo = await verificarPeriodoUsuario();

    if (
      checkInPeriodoAdicionado.current === "" ||
      checkOutPeriodoAdicionado.current === ""
    ) {
      error("Favor acertar período.");
    } else {
      if (Token) {
        const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/`;
        let formDataPeriodo1 = {
          cotaId: cotaId,
          checkIn: AlterarFormatoData(checkInPeriodoAdicionado.current),
          checkOut: AlterarFormatoData(checkOutPeriodoAdicionado.current),
          origem: Token.id,
        };

        try {
          const responseCriarPeriodo1 = await axios.post(
            URLPeriodo,
            formDataPeriodo1,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );

          if (responseCriarPeriodo1) {
            const sucessoPeriodoUsuario = await adicionarPeriodosUsuario(
              responseCriarPeriodo1.data.id
            );
            if (sucessoPeriodoUsuario) {
              setTimeout(() => {
                success("Período adicionado com sucesso!");
              }, 3000);

              setTimeout(() => {
                document.location.reload();
              }, 6000);
            }
          }
        } catch (error) {
          console.log("Não foi possível criar o período");
          error("Algo deu errado!");
        }
      } else {
        error("Favor fazer o login novamente!.");
        document.location.reload();
      }
    }
  };

  const adicionarPeriodosUsuario = async (
    periodoId: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URLPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
      const values = {
        periodoId: periodoId,
        cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
      };
      try {
        const response = await axios.post(URLPeriodoUsuario, values, {
          headers: { Authorization: Token.AuthStr },
        });

        return true;
      } catch (error) {
        console.error("Não foi possível criar o período Usuario");
        return false;
      }
    } else {
      return false;
    }
  };

  const CollectionCreateFormMaisPeriodo: React.FC<
    CollectionCreateFormPropsMaisPeriodo
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openMaisPeriodo}
        title="Adicionar período"
        okText="Adicionar"
        cancelText="Cancelar"
        onCancel={onCancel}
        width={300}
        onOk={() => {
          form
            .validateFields()
            .then((valuesMaisPeriodo) => {
              form.resetFields();
              onCreate(valuesMaisPeriodo);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Form.Item
              name="periodo"
              label="Período"
              // {...{ wrapperCol: { span: 9, offset: 2 } }}
            >
              <RangePicker
                placeholder={["check-in", "check-out"]}
                format={dateFormat}
                size={"large"}
                onChange={onRangeChangeMaisPeriodo}
              />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    );
  };

  //------------------------------------------\\
  const adicionarPeriodos = async () => {
    const Token = validateToken();

    if (Token) {
      const URLCTU = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/${nCotaUsuarioId.cotaUsuarioId}`;

      try {
        const responseCTU = await axios.get(URLCTU, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responseCTU) {
          switch (
            responseCTU.data.CotaTable.AptoTable.EmpreendimentoTable.origem
          ) {
            case 0:
              switch (
                responseCTU.data.CotaTable.AptoTable.EmpreendimentoTable
                  .cronograma
              ) {
                case 0:
                  if (responseCTU.data.CotaTable.AptoTable.origem === 0) {
                    document.location.href = `/adicionarPeriodos/?cotaUsuarioId=${nCotaUsuarioId.cotaUsuarioId}`;
                  } else {
                    setOpenMaisPeriodo(true);
                  }

                  break;
                case 1:
                  if (responseCTU.data.CotaTable.AptoTable.origem === 0) {
                    errorLongaDuracao(
                      "O seu empreendimento já tem os períodos pré-definidos em calendário e, portanto, já estão listados. Caso não encontre um período específico, verifique se o número da cota cadastrada é a correta."
                    );
                  } else {
                    setOpenMaisPeriodo(true);
                  }

                  break;
              }
              break;
            default:
              setOpenMaisPeriodo(true);
              break;
          }
        }
      } catch (error) {
        error("Há algo de errado!");
      }
    } else {
      document.location.href = "/login";
    }
  };

  const verificarInteresse = async (): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const usuarioId = Token.id;
      const URL = `${Globais.DOMINIOBACK}/interesse/usuario/${usuarioId}`;

      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        const interesses = response.data;

        // Verifica se todos os itens têm o status "ATENDIDO_MC"
        const todosAtendidoMC = interesses.every(
          (interesse: any) =>
            interesse.status === "ATENDIDO_MC" ||
            (interesse.alugar === 1 && interesse.trocar === 0)
        );

        // Retorna false se TODOS forem "ATENDIDO_MC", caso contrário, true
        return !todosAtendidoMC;
      } catch (error) {
        console.error("Erro ao verificar interesse:", error);
        return false;
      }
    } else {
      console.log("Token inválido");
      return false;
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Check-in",
      dataIndex: "checkIn",
      key: "checkIn",
      width: "15%",
      align: "center",
      filteredValue: filteredInfo.checkIn,

      ...getColumnSearchProps("checkIn"),
    },
    {
      title: "Check-out",
      dataIndex: "checkOut",
      key: "checkOut",
      width: "12%",
      align: "center",
      filteredValue: filteredInfo.checkOut,

      ...getColumnSearchProps("checkOut"),
    },
    {
      title: "",
      dataIndex: "especial",
      key: "especial",
      width: "5%",
      align: "center",
      filteredValue: filteredInfo.especial,
      filters: [
        { text: "Data especial", value: "Data_especial" },

        { text: "Data normal", value: "Data_normal" },
      ],

      onFilter: (value: any, record) => record.especial.includes(value),
      filterSearch: true,

      render: (item, row) =>
        row.especial === "Data_especial" ? (
          <Tooltip
            title={row.dataEspecial}
            enterTouchDelay={0} // Mostra o tooltip imediatamente ao toque
            leaveTouchDelay={3000} // Mantém o tooltip visível por 3 segundos após o toque
          >
            <StarsIcon color="warning" />
          </Tooltip>
        ) : row.especial === "Data_normal" ? (
          <Tooltip
            title={"Não é uma data especial."}
            enterTouchDelay={0}
            leaveTouchDelay={3000}
          >
            <HideSourceIcon sx={{ color: grey[500] }} />
          </Tooltip>
        ) : null,
    },
    {
      title: "Valor",
      dataIndex: "valorMin",
      key: "valorMin",
      width: "10%",
      align: "center",
    },
    {
      title: "Valor sugerido",
      dataIndex: "valorSugeridoSistema",
      key: "valorSugeridoSistema",
      width: "10%",
      align: "center",
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      width: "11%",
      filteredValue: filteredInfo.situacao,

      filters: [
        { text: "Alugar", value: "Alugar" },
        { text: "Trocar", value: "Trocar" },
        { text: "Alugar ou Trocar", value: "Alugar ou trocar" },
        { text: "Será utilizado", value: "Será utilizado" },
        { text: "Reservado por MC", value: "Reservado por MC" },
        { text: "Reservado pelo próprio", value: "Reservado pelo próprio" },
        { text: "Não definido", value: "Não definido" },
        {
          text: "Alugado ou utilizado parcialmente",
          value: "Alugado ou utilizado parcialmente",
        },
        {
          text: "Períodos fracionados reservados",
          value: "Períodos fracionados reservados",
        },
      ],
      onFilter: (value: any, record) => record.situacao.includes(value),
      filterSearch: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "9%",
      filteredValue: filteredInfo.status,

      filters: [
        { text: "Sem status", value: "SEM_STATUS" },

        { text: "Delegado", value: "DELEGADO" },
        { text: "Não pertube", value: "NAO_PERTUBE" },

        { text: "Finalizado", value: "FINALIZADO" },

        { text: "Valor alto", value: "VALOR_ALTO" },
        { text: "Em alteração", value: "ALTERANDO" },
      ],

      onFilter: (value: any, record) => record.status.includes(value),
      filterSearch: true,
      render: (item, row) =>
        row.status === "DELEGADO" ? (
          <Tooltip title='Conforme selecionado, os valores desse período estão sendo administrados pela Multicotas. Caso deseje retirar esse estado, basta clicar em "Delegar" novamente.'>
            <PersonOffIcon color="primary" />
          </Tooltip>
        ) : row.status === "NAO_PERTUBE" ? (
          <Tooltip title='Conforme selecionado, a Multicotas não fará sugestões de preço para esse período. Caso deseje retirar esse estado, basta clicar em "Não pertube" novamente.'>
            {/* <SentimentVeryDissatisfiedIcon color="primary" /> */}
            <DoDisturbOnIcon sx={{ color: red[900] }} />
          </Tooltip>
        ) : row.status === "FINALIZADO" ? (
          <Tooltip title="Finalizado">
            <CheckCircleOutlineIcon color="success" />
          </Tooltip>
        ) : row.status === "VALOR_ALTO" ? (
          <Tooltip title="Valor acima do sugerido">
            <ThumbDownIcon color="error" />
          </Tooltip>
        ) : row.status === "SEM_STATUS" && row.situacao !== "Não definido" ? (
          <Tooltip title="Tudo certo!">
            <ThumbUpIcon color="success" />
          </Tooltip>
        ) : row.situacao === "Não definido" ? (
          <Tooltip title="Definir um propósito para o período">
            <HelpIcon color="warning" />
          </Tooltip>
        ) : row.status === "ALTERANDO" ? (
          <Tooltip title="Nesse momento, a Multicotas está mexendo nesse período. Você receberá um e-mail assim que terminarmos.">
            <ChangeCircleIcon style={{ color: "red" }} />
          </Tooltip>
        ) : null,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "9%",
      align: "center",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                situacao.current = row.situacao;
                divulgado.current = row.divulgado;
                periodoUsuario.current = row.periodoUsuarioId;
                periodo.current = row.periodoId;
                valor.current = row.valorMin;
                fracionamento.current = row.fracionamento;
                valorSugerido.current = row.valorSugerido;
                valorSugeridoSistema.current = row.valorSugeridoSistema;
                statusAtual.current =
                  row.status === "VALOR_ALTO" ? "SEM_STATUS" : row.status;
                statusAnterior.current = row.statusAnterior;
                valorSugeridoInicial.current = row.valorSugeridoInicial;

                checkInPeriodo.current = row.checkIn;
                // datasSugeridas(checkIn1.current);

                checkOutPeriodo.current = row.checkOut;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const validarValorDiarias = (
    valorPrincipal: any,
    checkInFracao1: any,
    checkOutFracao1: any,
    valorFracao1: any,
    checkInFracao2: any,
    checkOutFracao2: any,
    valorFracao2: any
  ): boolean => {
    diferenca1.current = CalcularDiferencaDias(
      AlterarFormatoData(checkOutFracao1),
      AlterarFormatoData(checkInFracao1)
    );
    diferenca2.current = CalcularDiferencaDias(
      AlterarFormatoData(checkOutFracao2),
      AlterarFormatoData(checkInFracao2)
    );

    valorDiariaPrincipal.current = valorPrincipal / 7;
    valorDiariaFracao1.current = valorFracao1 / diferenca1.current;
    valorDiariaFracao2.current = valorFracao2 / diferenca2.current;

    if (
      valorDiariaPrincipal.current >= valorDiariaFracao1.current &&
      valorDiariaPrincipal.current >= valorDiariaFracao2.current
    ) {
      colorPrincipal.current = "blue";
      color1fracao.current = "red";
      color2fracao.current = "red";
      return false;
    } else {
      if (valorDiariaPrincipal.current >= valorDiariaFracao1.current) {
        colorPrincipal.current = "blue";
        color1fracao.current = "red";
        color2fracao.current = "black";
        return false;
      } else {
        if (valorDiariaPrincipal.current >= valorDiariaFracao2.current) {
          colorPrincipal.current = "blue";
          color1fracao.current = "black";
          color2fracao.current = "red";
          return false;
        } else {
          if (diferenca1.current > diferenca2.current) {
            if (valorDiariaFracao1.current >= valorDiariaFracao2.current) {
              colorPrincipal.current = "black";
              color1fracao.current = "blue";
              color2fracao.current = "red";
              return false;
            } else {
              return true;
            }
          } else {
            if (valorDiariaFracao2.current >= valorDiariaFracao1.current) {
              colorPrincipal.current = "black";
              color1fracao.current = "red";
              color2fracao.current = "blue";
              return false;
            } else {
              return true;
            }
          }
        }
      }
    }
  };

  const atualizarPeriodosFracionados = async (valuesFracao: any) => {
    const Token = validateToken();

    if (valuesFracao.checkIn1 === undefined) {
      valuesFracao.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracao.checkOut1 === undefined) {
      valuesFracao.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracao.checkIn2 === undefined) {
      valuesFracao.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracao.checkOut2 === undefined) {
      valuesFracao.checkOut2 = checkOutPeriodo.current;
    }
    checkInPrimeiroPeriodo.current = valuesFracao.checkIn1;
    checkOutPrimeiroPeriodo.current = valuesFracao.checkOut1;
    checkInSegundoPeriodo.current = valuesFracao.checkIn2;
    checkOutSegundoPeriodo.current = valuesFracao.checkOut2;
    valorPrimeiroPeriodo.current = valuesFracao.valorMin1;
    valorSegundoPeriodo.current = valuesFracao.valorMin2;

    switch (situacao.current) {
      case "Alugar":
        situacaoAnterior.current = "ALUGAR";
        break;
      case "Alugar ou trocar":
        situacaoAnterior.current = "ALUGAR_TROCAR";
        break;
      case "Trocar":
        situacaoAnterior.current = "TROCAR";
        break;
      case "Não definido":
        situacaoAnterior.current = "SEM_STATUS";
        break;
      case "Reservado pelo próprio":
        situacaoAnterior.current = "CONCLUIDO_PELO_PROPRIO";
        break;
      case "Será utilizado":
        situacaoAnterior.current = "UTILIZADO";
        break;
    }
    if (statusAtual.current === "VALOR_ALTO") {
      statusAtual.current = "SEM_STATUS";
    }

    const valorMin = valor.current;

    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuario.current);

    if (Token) {
      disponibilizarPeriodo.filter(async (p: any) => {
        if (p.id === periodoUsuario.current) {
          if (await p.children) {
            p.children.filter(async (q: any) => {
              if ((await q.fracionamento) === (await p.id)) {
                const URLGetPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/${q.id}`;

                try {
                  const responsePeriodoUsuarioGet = await axios.get(
                    URLGetPeriodoUsuario,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responsePeriodoUsuarioGet) {
                    const URLGetPeriodo = `${Globais.DOMINIOBACK}/periodo/${responsePeriodoUsuarioGet.data.periodoId}`;
                    const responsePeriodoGet = await axios.get(URLGetPeriodo, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (responsePeriodoGet) {
                      if (
                        formatarData(responsePeriodoGet.data.checkIn) ===
                        checkInPrimeiroPeriodo.current
                      ) {
                        let formDataPeriodoUsuario1 = {};
                        if (alugarOuTrocar.current === 1) {
                          if (statusAtual.current === "DELEGADO") {
                            if (await divulgando) {
                              formDataPeriodoUsuario1 = {
                                alugar: 1,
                                trocar: 0,
                                utilizar: 0,
                                concluido: 0,
                                valorSugerido: valorPrimeiroPeriodo.current,
                                statusAnterior: statusAtual.current,
                                status: "ALTERANDO",
                                situacaoAnterior: situacaoAnterior.current,
                              };
                            } else {
                              formDataPeriodoUsuario1 = {
                                alugar: 1,
                                trocar: 0,
                                utilizar: 0,
                                concluido: 0,
                                valorMin: valorPrimeiroPeriodo.current,
                                statusAnterior: statusAtual.current,
                                status: "DELEGADO",
                                situacaoAnterior: situacaoAnterior.current,
                              };
                            }
                          } else {
                            if (statusAtual.current === "NAO_PERTUBE") {
                              if (await divulgando) {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "ALTERANDO",
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorPrimeiroPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "NAO_PERTUBE",
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (await divulgando) {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "VALOR_ALTO"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: "ALTERANDO",
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorPrimeiroPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "VALOR_ALTO"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,

                                  alterado: 1,
                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          }
                        } else {
                          if (alugarOuTrocar.current === 2) {
                            if (statusAtual.current === "DELEGADO") {
                              if (await divulgando) {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 1,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorPrimeiroPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "ALTERANDO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario1 = {
                                  alugar: 1,
                                  trocar: 1,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorPrimeiroPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "DELEGADO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (statusAtual.current === "NAO_PERTUBE") {
                                if (await divulgando) {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorPrimeiroPeriodo.current,
                                    statusAnterior: statusAtual.current,
                                    status: "ALTERANDO",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorPrimeiroPeriodo.current,
                                    statusAnterior: statusAtual.current,
                                    status: "NAO_PERTUBE",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (await divulgando) {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorPrimeiroPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "VALOR_ALTO"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,
                                    status: "ALTERANDO",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario1 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorPrimeiroPeriodo.current,
                                    statusAnterior:
                                      statusAtual.current === "VALOR_ALTO"
                                        ? "SEM_STATUS"
                                        : statusAtual.current,

                                    alterado: 1,

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              }
                            }
                          }
                        }

                        const responsePeriodoUsuarioPut = await axios.put(
                          URLGetPeriodoUsuario,
                          formDataPeriodoUsuario1,
                          {
                            headers: { Authorization: Token.AuthStr },
                          }
                        );

                        if (responsePeriodoUsuarioPut) {
                        } else {
                          error("Algo deu errado");
                        }
                      } else {
                        let formDataPeriodoUsuario2 = {};
                        if (alugarOuTrocar.current === 1) {
                          if (statusAtual.current === "DELEGADO") {
                            if (await divulgando) {
                              formDataPeriodoUsuario2 = {
                                alugar: 1,
                                trocar: 0,
                                utilizar: 0,
                                concluido: 0,
                                valorSugerido: valorSegundoPeriodo.current,
                                statusAnterior: statusAtual.current,
                                status: "ALTERANDO",

                                situacaoAnterior: situacaoAnterior.current,
                              };
                            } else {
                              formDataPeriodoUsuario2 = {
                                alugar: 1,
                                trocar: 0,
                                utilizar: 0,
                                concluido: 0,
                                valorMin: valorSegundoPeriodo.current,
                                statusAnterior: statusAtual.current,
                                status: "DELEGADO",

                                situacaoAnterior: situacaoAnterior.current,
                              };
                            }
                          } else {
                            if (statusAtual.current === "NAO_PERTUBE") {
                              if (await divulgando) {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "ALTERANDO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorSegundoPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "NAO_PERTUBE",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (await divulgando) {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,

                                  statusAnterior:
                                    statusAtual.current === "VALOR_ALTO"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,
                                  status: "ALTERANDO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 0,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorSegundoPeriodo.current,
                                  statusAnterior:
                                    statusAtual.current === "VALOR_ALTO"
                                      ? "SEM_STATUS"
                                      : statusAtual.current,

                                  alterado: 1,

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            }
                          }
                        } else {
                          if (alugarOuTrocar.current === 2) {
                            if (statusAtual.current === "DELEGADO") {
                              if (await divulgando) {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 1,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorSugerido: valorSegundoPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "ALTERANDO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              } else {
                                formDataPeriodoUsuario2 = {
                                  alugar: 1,
                                  trocar: 1,
                                  utilizar: 0,
                                  concluido: 0,
                                  valorMin: valorSegundoPeriodo.current,
                                  statusAnterior: statusAtual.current,
                                  status: "DELEGADO",

                                  situacaoAnterior: situacaoAnterior.current,
                                };
                              }
                            } else {
                              if (statusAtual.current === "NAO_PERTUBE") {
                                if (await divulgando) {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior: statusAtual.current,
                                    status: "ALTERANDO",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorSegundoPeriodo.current,
                                    statusAnterior: statusAtual.current,
                                    status: "NAO_PERTUBE",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              } else {
                                if (await divulgando) {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorSugerido: valorSegundoPeriodo.current,
                                    statusAnterior: statusAtual.current,
                                    status: "ALTERANDO",

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                } else {
                                  formDataPeriodoUsuario2 = {
                                    alugar: 1,
                                    trocar: 1,
                                    utilizar: 0,
                                    concluido: 0,
                                    valorMin: valorSegundoPeriodo.current,
                                    statusAnterior: statusAtual.current,

                                    alterado: 1,

                                    situacaoAnterior: situacaoAnterior.current,
                                  };
                                }
                              }
                            }
                          }
                        }

                        const responsePeriodoUsuarioPut2 = await axios.put(
                          URLGetPeriodoUsuario,
                          formDataPeriodoUsuario2,
                          {
                            headers: { Authorization: Token.AuthStr },
                          }
                        );

                        if (responsePeriodoUsuarioPut2) {
                        } else {
                          error("Algo deu errado");
                        }
                      }
                    }
                  }
                } catch (e) {
                  error("Algo deu errado");
                }
              }
            });
          }
        }
      });
      return true;
    }
  };

  const ControlarPeriodosFracionadosEPrincipal = async (
    valuesFracaoCompleta: any
  ) => {
    setOpenModalFracaoCompleta(false);
    setOpenModalFracaoCompletaAtualizar(false);

    const Token = validateToken();

    if (valuesFracaoCompleta.checkInPrincipal === undefined) {
      valuesFracaoCompleta.checkInPrincipal = checkInPeriodo.current;
    }

    if (valuesFracaoCompleta.checkOutPrincipal === undefined) {
      valuesFracaoCompleta.checkOutPrincipal = checkOutPeriodo.current;
    }

    if (valuesFracaoCompleta.checkIn1 === undefined) {
      valuesFracaoCompleta.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracaoCompleta.checkOut1 === undefined) {
      valuesFracaoCompleta.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracaoCompleta.checkIn2 === undefined) {
      valuesFracaoCompleta.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracaoCompleta.checkOut2 === undefined) {
      valuesFracaoCompleta.checkOut2 = checkOutPeriodo.current;
    }

    checkInPrimeiroPeriodo.current = valuesFracaoCompleta.checkIn1;
    checkOutPrimeiroPeriodo.current = valuesFracaoCompleta.checkOut1;
    checkInSegundoPeriodo.current = valuesFracaoCompleta.checkIn2;
    checkOutSegundoPeriodo.current = valuesFracaoCompleta.checkOut2;
    valorPrimeiroPeriodo.current = valuesFracaoCompleta.valorMin1;
    valorSegundoPeriodo.current = valuesFracaoCompleta.valorMin2;
    valor.current = valuesFracaoCompleta.valorMinPrincipal;

    let resultado = validarValorDiarias(
      valor.current,
      checkInPrimeiroPeriodo.current,
      checkOutPrimeiroPeriodo.current,
      valorPrimeiroPeriodo.current,
      checkInSegundoPeriodo.current,
      checkOutSegundoPeriodo.current,
      valorSegundoPeriodo.current
    );

    if (resultado) {
      disponibilizarPeriodo.map(async (p: any) => {
        if (p.id === periodoUsuario.current) {
          if (p.children) {
            p.children.filter((q: any) => {
              if (periodoUsuario1Fracao.current === 0) {
                periodoUsuario1Fracao.current = q.id;
              } else {
                periodoUsuario2Fracao.current = q.id;
              }
            });
          }
        }
      });

      const result = atualizarValorAluguel(
        periodoUsuario.current,
        alugarOuTrocar.current,
        true
      );

      if (await result) {
        const resultFracionados = atualizando.current
          ? atualizarPeriodosFracionados(valuesFracaoCompleta)
          : criarPeriodosFracionados(valuesFracaoCompleta);

        if (await resultFracionados) {
          let divulgando = verificarSeTemPeriodoDivulgado(
            periodoUsuario.current
          );
          let formDataEmail = {
            tipoEmail: 18,
            valorPrincipal: 2,
            valor1Fracao: 2,
            valor2Fracao: 2,
            periodoUsuarioId: periodoUsuario.current,
            periodoUsuarioId1Fracao: periodoUsuario1Fracao.current,
            periodoUsuarioId2Fracao: periodoUsuario2Fracao.current,
            valorSugeridoPrincipal: valor.current,
            valorSugerido1Fracao: valorPrimeiroPeriodo.current,
            valorSugerido2Fracao: valorSegundoPeriodo.current,
          };

          let resultEmail;
          if (await divulgando) {
            resultEmail = true;
          } else {
            resultEmail = enviarEmail(formDataEmail);
          }

          if (await resultEmail) {
            success("Períodos atualizados com sucesso!");
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          } else {
            error("Não poi possível enviar e-mail de comprovação.");
          }
        } else {
          error("Há algo de errado. Entre em contato conosco 1.");
        }
      } else {
        error("Há algo de errado. Entre em contato conosco 2.");
      }
    } else {
      setOpenDiariaErrada(true);
    }
  };

  const onSubmitAtualizarValorAluguel = async (valuesValor: any) => {
    setOpenValor(false);
    let divulgando = verificarSeTemPeriodoDivulgado(periodoUsuario.current);
    let valorAnalisado = tratamentoValoresInput(valuesValor.valorMin);
    if (valorAnalisado) {
      valor.current = valuesValor.valorMin;
      let periodoPrincipal;
      let periodoFracao1 = 0;
      let periodoFracao2 = 0;
      let periodoSelecionado = 0;
      let situacaoAnterior1;
      let situacaoAnterior2;
      let situacaoAnteriorPrincipal;
      let temFracoes = false;
      let valorPrincipal = 0;
      let valor1Fracao = 0;
      let valor2Fracao = 0;

      //busca os ids dos períodos.
      disponibilizarPeriodo.map((p: any) => {
        p.key = p.id;
        if (p.id === periodoUsuario.current) {
          periodoPrincipal = p.id;
          situacaoAnteriorPrincipal = qualSituacao(0, 0, 0, 0, 2, p.situacao);

          if (p.children) {
            temFracoes = true;
            p.children.map((q: any) => {
              if (periodoFracao1 === 0) {
                periodoFracao1 = q.id;
              } else {
                periodoFracao2 = q.id;
              }
            });
          }
        } else {
          if (p.children) {
            p.children.map((q: any) => {
              if (q.id === periodoUsuario.current) {
                temFracoes = true;
                periodoFracao1 = q.id;
                periodoSelecionado = 1;
                periodoPrincipal = q.fracionamento;
                situacaoAnterior1 = qualSituacao(0, 0, 0, 0, 2, q.situacao);
                p.children.filter((z: any) => {
                  if (z.fracionamento === q.fracionamento && z.id !== q.id) {
                    periodoFracao2 = z.id;
                  }
                });
              }
            });
          }
        }
      });

      //aqui

      if (alterandoValor.current && (await divulgando)) {
        if (periodoSelecionado === 0) {
          formDataPrincipal.current = {
            alugar: 1,
            trocar: alugarOuTrocar.current === 1 ? 0 : 1,
            concluido: 0,
            utilizar: 0,
            situacaoAnterior: situacaoAnteriorPrincipal,
            valorSugerido: formatarMoeda(valor.current),
            statusAnterior: statusAtual.current,
            status: "ALTERANDO",
            caso: 2,
            periodoUsuario: periodoPrincipal,
          };
          formData1.current = {
            status: "ALTERANDO",
            caso: 2,
            statusAnterior: statusAtual.current,
            periodoUsuario: periodoFracao1,
          };
          formData2.current = {
            status: "ALTERANDO",
            caso: 2,
            statusAnterior: statusAtual.current,
            periodoUsuario: periodoFracao2,
          };
        } else {
          formDataPrincipal.current = {
            status: "ALTERANDO",
            caso: 2,
            statusAnterior: statusAtual.current,
            periodoUsuario: periodoPrincipal,
          };
          formData1.current = {
            alugar: 1,
            trocar: alugarOuTrocar.current === 1 ? 0 : 1,
            concluido: 0,
            utilizar: 0,
            situacaoAnterior: situacaoAnterior1,
            valorSugerido: formatarMoeda(valor.current),
            statusAnterior: statusAtual.current,
            status: "ALTERANDO",
            caso: 2,
            periodoUsuario: periodoFracao1,
          };
          formData2.current = {
            status: "ALTERANDO",
            caso: 2,
            periodoUsuario: periodoFracao2,
            statusAnterior: statusAtual.current,
          };
        }

        const result1 = atualizarPeriodoUsuario(formDataPrincipal.current);

        if (temFracoes) {
          if ((await result1) === 1) {
            const result2 = atualizarPeriodoUsuario(formData1.current);

            if ((await result2) === 1) {
              const result3 = atualizarPeriodoUsuario(formData2.current);

              if ((await result3) === 1) {
                successLongaDuracao("Períodos atualizados com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Não foi possível atualizar o segundo período.");
              }
            } else {
              error("Não foi possível atualizar o primeiro período.");
            }
          } else {
            error("Não foi possível atualizar o período principal.");
          }
        } else {
          successLongaDuracao("Período atualizado com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        }
      } else {
        atualizarValorAluguel(
          periodoUsuario.current,
          alugarOuTrocar.current,
          false
        );
      }
    } else {
      error("Ops. Acho que você não incluiu um número válido.");
    }
  };
  const onSubmitAtualizarValorAluguelFracaoCompleta = (
    valuesFracaoCompleta: any
  ) => {
    setOpenModalFracaoCompleta(false);
    setOpenModalFracaoCompletaAtualizar(false);
    let valorAnalisado1 = tratamentoValoresInput(
      valuesFracaoCompleta.valorMin1
    );
    let valorAnalisado2 = tratamentoValoresInput(
      valuesFracaoCompleta.valorMin2
    );
    let valorAnalisadoPrincipal = tratamentoValoresInput(
      valuesFracaoCompleta.valorMinPrincipal
    );

    if (!valorAnalisado1 || !valorAnalisado2 || !valorAnalisadoPrincipal) {
      error("Ops. Acho que você não incluiu um número válido.");
    } else {
      if (
        valorAnalisadoPrincipal < valorAnalisado1 ||
        valorAnalisadoPrincipal < valorAnalisado2
      ) {
        error("Uma fração não pode valer mais que o período principal.");
      } else {
        ControlarPeriodosFracionadosEPrincipal(valuesFracaoCompleta);
      }
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<any>({
    situacao: null,
    divulgado: null,
    periodoUsuario: null,
    periodo: null,
    valor: null,
    valorSugerido: null,
    fracionamento: null,
    valorSugeridoSistema: null,
    statusAtual: null,
    statusAnterior: null,
    dataSugestao: null,
    active: null,
    cotaUsuarioId: null,
    specialDate: null,
    checkInPeriodo: null,
    alterando: null,
    checkOutPeriodo: null,
  });

  const showModalAcoes = (data: any) => {
    setSelectedData(data);
    // Define os dados da linha selecionada
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal excluir assinatura
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  const getSituacaoColor = (row: any): string => {
    const hoje = new Date();
    const checkOut = new Date(AlterarFormatoData(row.checkOut));
    const situacao = row.situacao?.toLowerCase();



    const situacoesVerde = [
      "alugar",
      "alugar ou trocar",
      "trocar",
      "alugado",
      "alugado ou utilizado parcialmente"
      
    ];

    
    // Situação Fechado (Vermelho): quando o checkOut é anterior a hoje E situação está em uma das listadas
    if (
      checkOut < hoje &&
      ["alugar", "alugar ou trocar", "trocar"].includes(situacao)
    ) {
      return "red";
    }
    // Situação Fechado (Laranja): quando o checkOut é anterior a hoje E situação é "alugado ou utilizado parcialmente"
    if (
      checkOut < hoje &&
      ["alugado ou utilizado parcialmente"].includes(situacao)
    ) {
      return "orange";
    }
    // Não definido: Branco
    if (situacao === "não definido") {
      return "white";
    }
    // // Não definido: Branco
    // if (situacao === "alugado ou utilizado parcialmente") {
    //   return "";
    // }

    // Situações Verdes
    if (situacoesVerde.includes(situacao)) {
      return "green";
    }

    // Utilizar ou Trocado: Azul
    if (situacao === "será utilizado" || situacao === "trocado") {
      return "blue";
    }

    // Reservado: Roxo
    if (
      situacao === "reservado" ||
      situacao === "reservado pelo próprio" ||
      situacao === "reservado por mc" ||
      situacao === "períodos fracionados reservados"
    ) {
      return "purple";
    }

    return "#999"; // Cinza padrão
  };

  const [modalFiltroAberto, setModalFiltroAberto] = useState(false);
  const aplicarFiltroMobile = (valores: any) => {
    const filtrosAplicados = {
      checkIn: valores.checkIn
        ? [dayjs(valores.checkIn).format("YYYY-MM-DD")]
        : null,
      checkOut: valores.checkOut
        ? [dayjs(valores.checkOut).format("YYYY-MM-DD")]
        : null,
      especial: valores.especial ? [true] : null,
      situacao: valores.situacao?.length > 0 ? valores.situacao : null,

      status: valores.status ? [valores.status] : null,
    };

    setFilteredInfo(filtrosAplicados);
    localStorage.setItem(
      "filtrosDispPeriodo",
      JSON.stringify(filtrosAplicados)
    );
    setSemFiltros(false);
    setCurrentPage(1);
  };

  const aplicarFiltrosNaLista = (
    lista: DataType[],
    filtros: Record<string, FilterValue | null>
  ) => {
    let listaFiltrada = [...lista];

    const getSituacaoVisivel = (item: DataType): string => {
    const checkOut = dayjs(item.checkOut, "DD/MM/YYYY");
    const hoje = dayjs();

    // Se checkOut passou e estava como Alugar ou Trocar => Fechado
    if (checkOut.isBefore(hoje, "day") && ["Alugar", "Trocar", "Alugar ou trocar"].includes(item.situacao)) {
      return "fechado";
    }
    // Se checkOut passou e estava como Alugado ou utilizado parcialmente => Fechado parcialmente
    if (checkOut.isBefore(hoje, "day") && ["Alugado ou utilizado parcialmente"].includes(item.situacao)) {
      return "fechado_parcialmente";
    }
 

    return item.situacao;
  };

    // Filtro de Check-in
    if (filtros.checkIn && filtros.checkIn.length > 0) {
      const checkInFilterValue = filtros.checkIn[0] as string;
      listaFiltrada = listaFiltrada.filter((item) =>
        dayjs(item.checkIn, "DD/MM/YYYY").isSame(
          dayjs(checkInFilterValue, "YYYY-MM-DD"),
          "day"
        )
      );
    }

    // Filtro de Check-out
    if (filtros.checkOut && filtros.checkOut.length > 0) {
      const checkOutFilterValue = filtros.checkOut[0] as string;
      listaFiltrada = listaFiltrada.filter((item) =>
        dayjs(item.checkOut, "DD/MM/YYYY").isSame(
          dayjs(checkOutFilterValue, "YYYY-MM-DD"),
          "day"
        )
      );
    }

    // Filtro de "Data especial" (especial)
    if (filtros.especial && filtros.especial.length > 0) {
      // Se "Data_especial" foi selecionada, filtra por 'Data_especial'
      if (filtros.especial[0] === "Data_especial") {
        listaFiltrada = listaFiltrada.filter(
          (item) => item.especial === "Data_especial"
        );
      }
      // Se "Data_normal" foi selecionada, filtra por 'Data_normal'
      if (filtros.especial[0] === "Data_normal") {
        listaFiltrada = listaFiltrada.filter(
          (item) => item.especial === "Data_normal"
        );
      }
    }
      //   if (filtros.especial && filtros.especial.length > 0) {
      // const especiaisSelecionados = filtros.especial as string[];
      // listaFiltrada = listaFiltrada.filter((item) =>
      //   especiaisSelecionados.includes(item.especial)
      // );
// }

    // Filtro de Situação
    // Situação (agora com base na situação visível)
        if (filtros.situacao && filtros.situacao.length > 0) {
          const hoje = dayjs();

            listaFiltrada = listaFiltrada.filter((item) => {
              const checkOutDate = dayjs(item.checkOut, "DD/MM/YYYY");

              const situacaoOriginal = item.situacao;
              let situacaoTratada;
              switch(item.situacao) {
                case "Alugar":
                  if (checkOutDate.isBefore(hoje, "day")) {
                    situacaoTratada = "fechado";
                  }else{
                    situacaoTratada = "Alugar";
                  }
                  break;
                case "Alugar ou trocar":
                  if (checkOutDate.isBefore(hoje, "day")) {
                    situacaoTratada = "fechado";
                  }else{
                    situacaoTratada = "Alugar ou trocar";
                  }
                  break;
                case "Alugado ou utilizado parcialmente":
                  if (checkOutDate.isBefore(hoje, "day")) {
                    situacaoTratada = "fechado_parcialmente";
                  }else{
                    situacaoTratada = "Alugado ou utilizado parcialmente";
                  }
                  break;
                case "Trocar":
                  if (checkOutDate.isBefore(hoje, "day")) {
                    situacaoTratada = "fechado";
                  }else{
                    situacaoTratada = "Trocar";      
                  }
                  break;
                case "Será utilizado":
                  situacaoTratada = "Será utilizado";
                  break;
                case "Reservado pelo próprio":
                  situacaoTratada = "Reservado pelo próprio";
                  break;
                case "Reservado por MC (Multicotas)":
                  situacaoTratada = "Reservado por MC (Multicotas)";
                  break;
                case "Períodos fracionados reservados":
                  situacaoTratada = "Períodos fracionados reservados";
                  break;
               
                  default:
                    situacaoTratada = situacaoOriginal;
                }
              // const situacaoTratada =
              //   checkOutDate.isBefore(hoje, "day") &&
              //   ["Alugar", "Trocar", "Alugar ou trocar"].includes(situacaoOriginal)
              //     ? "fechado"
              //     : situacaoOriginal;

              // Comparação flexível com minúsculas
              const filtrosLower = (filtros.situacao as string[] | undefined)?.filter((s): s is string => typeof s === "string").map((s) => s.toLowerCase());

              return filtrosLower?.includes(situacaoTratada.toLowerCase());
            });
        }
    // Filtro de Status
      if (filtros.status && filtros.status.length > 0) {
          const statusSelecionados = filtros.status as string[];
          listaFiltrada = listaFiltrada.filter((item) =>
            statusSelecionados.includes(item.status)
          );
        }

    return listaFiltrada;
  };

  const [openModalReserva, setOpenModalReserva] = useState<boolean>(false);
  const handleFecharReseva = () => {
    setOpenModalReserva(false);
  };

  const handleCreate = (values: { valorMin: number }) => {
    const Token = validateToken()?.AuthStr;
    Reservar(Token, periodoUsuario.current, values.valorMin);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : isMobile ? (
        <Container>
          {contextHolder}
          {showAlert && (
            <div>
              <Alert
                message="Atenção"
                description="Você ainda não possui interesses válidos. Cadastre um novo interesse para continuar."
                type="info"
                showIcon
              />
            </div>
          )}
          <Flex vertical style={{ overflow: "auto", padding: 15 }}>
            {/* Cabeçalho com seta e título */}
            <Row align="middle" gutter={16} style={{ marginBottom: 24 }}>
              <Col flex="40px">
                <ContainerSeta>
                  <a href="/cadastroCotas">
                    <ArrowBackIcon color="primary" />
                  </a>
                </ContainerSeta>
              </Col>

              <Col flex="auto">
                {nomeEmpreend.current && numeroApto.current && (
                  <Flex align="center" justify="center" wrap="wrap">
                    <CalendarMonthIcon
                      color="primary"
                      fontSize="large"
                      style={{ marginRight: 8 }}
                    />
                    <Title level={5} style={{ margin: 0, textAlign: "center" }}>
                      {`Períodos de ${nomeEmpreend.current} - Apartamento ${numeroApto.current}`}
                    </Title>
                  </Flex>
                )}
              </Col>
            </Row>

            {/* Botões de ação */}
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: 16 }}
            >
              <Col>
                <Button onClick={adicionarPeriodos} ref={ref1} type="primary">
                  + Período
                </Button>
              </Col>
              <Col>
                <SituacaoInfoModal />
              </Col>

              <Col>
                <Button
                  onClick={() => setModalFiltroAberto(true)}
                  type="primary"
                >
                  {<FilterAltIcon />}
                </Button>
              </Col>
            </Row>
          </Flex>
          <ContainerLista>
            {aplicarFiltrosNaLista(disponibilizarPeriodo, filteredInfo).map(
              (row: any, index: number) => (
                <Row
                  key={`${row.key}-${index}`}
                  style={{ width: "100%", margin: 0, padding: 0 }}
                >
                  <Col span={24}>
                    <div
                      onClick={() => abrirModalFracionados(row)}
                      style={{
                        width: "100%",
                        borderBottom: "3px solid #C3CDC7",
                        padding: "10px 15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        cursor: "pointer",
                        background: "#fff",
                      }}
                    >
                   
                            <div
                              style={{
                                whiteSpace: "nowrap",
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                minHeight: "32px",
                              }}
                            >
                              <Tooltip title={row.situacao}>
                                <div
                                  style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    backgroundColor: getSituacaoColor(row),
                                    border: "grey solid 1px",
                                  }}
                                />
                              </Tooltip>
                              <span>
                                De {row.checkIn} a {row.checkOut}
                              </span>
                              {row.children?.length > 0 ? (
                                <span title="Possui períodos fracionados">📂</span>
                              ) : (
                                <span title="Sem frações" style={{ visibility: "hidden" }}>
                                  📂
                                </span>
                              )}
                            </div>

                            <Button
                              type="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                showModalAcoes({
                                  situacao: row.situacao,
                                  divulgado: row.divulgado,
                                  periodoUsuario: row.id,
                                  periodo: row.periodoId,
                                  valor: row.valorMin,
                                  valorSugerido: row.valorSugerido,
                                  fracionamento: row.fracionamento,
                                  valorSugeridoSistema: row.valorSugeridoSistema,
                                  statusAtual: row.status,
                                  statusAnterior: row.statusAnterior,
                                  dataSugestao: row.dataSugestao,
                                  active: +row.active,
                                  cotaUsuarioId: +row.idCTU,
                                  specialDate: row.especial,
                                  checkInPeriodo: row.checkIn,
                                  alterando: row.alterado,
                                  checkOutPeriodo: row.checkOut,
                                });
                              }}
                              style={{
                                backgroundColor: "#003644",
                                borderColor: "#003644",
                                color: "white",
                                padding: "3px 11px",
                                width: "60px",
                              }}
                            >
                              Ações
                            </Button>
                        
                        
                      
                      </div>
                    
                  </Col>
                </Row>
              )
            )}
          </ContainerLista>
        </Container>
      ) : (
        <Container>
          {contextHolder}

          {showAlert && (
            <Alert
              message="Atenção"
              description="Você ainda não possui interesses válidos. Cadastre um novo interesse para continuar."
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <Flex vertical style={{ overflow: "auto", padding: 24 }}>
            {/* Cabeçalho com seta e título */}
            <Row align="middle" gutter={16} style={{ marginBottom: 24 }}>
              <Col flex="40px">
                <ContainerSeta>
                  <a href="/cadastroCotas">
                    <ArrowBackIcon color="primary" />
                  </a>
                </ContainerSeta>
              </Col>

              <Col flex="auto">
                {nomeEmpreend.current && numeroApto.current && (
                  <Flex align="center" justify="center" wrap="wrap">
                    <CalendarMonthIcon
                      color="primary"
                      fontSize="large"
                      style={{ marginRight: 8 }}
                    />
                    <Title level={3} style={{ margin: 0, textAlign: "center" }}>
                      {`Períodos de ${nomeEmpreend.current} - Apartamento ${numeroApto.current}`}
                    </Title>
                  </Flex>
                )}
              </Col>
            </Row>

            {/* Botões de ação */}
            <Row
              justify="end"
              align="middle"
              style={{ marginBottom: 5, gap: 25 }}
            >
              <Col>
                <Button onClick={adicionarPeriodos} ref={ref1} type="primary">
                  + Período
                </Button>
              </Col>

              <Col>
                <Button
                  onClick={handleFilter}
                  type="primary"
                  disabled={semFiltros}
                >
                  {semFiltros ? <FilterAltIcon /> : <FilterAltOffIcon />}
                </Button>
              </Col>
            </Row>
          </Flex>
          <ContainerLista>
            <Table
              columns={columns}
              dataSource={disponibilizarPeriodo}
              onChange={onChange}
              pagination={{ defaultCurrent: currentPage }}
              bordered
              tableLayout="fixed"
            />
          </ContainerLista>
        </Container>
      )}
      <Modal
        title="Problemas no valor da diária!"
        open={openDiariaErrada}
        onOk={() => {
          colorPrincipal.current = "black";
          color1fracao.current = "black";
          color2fracao.current = "black";
          setOpenDiariaErrada(false);

          setOpenModalFracaoCompletaAtualizar(true);
        }}
        onCancel={() => {
          colorPrincipal.current = "black";
          color1fracao.current = "black";
          color2fracao.current = "black";
          setOpenDiariaErrada(false);
          setOpenModalFracaoCompletaAtualizar(true);
        }}
        okText="Ok"
        // cancelText="Não"
      >
        <p>
          O valor da diária de um período menor deve ser mais caro (exigência
          das plataformas de anúncio):
          <br />
          Azul - Período com mais dias, mais caro ou mesmo valor. <br />
          Vermelho - Período com menos dias, mais barato ou mesmo valor.
        </p>

        <Flex align="center" justify="center">
          <table>
            <tr>
              <td style={{ color: `${colorPrincipal.current}` }}>
                Principal (7 dias):{" "}
              </td>
              <td style={{ color: `${colorPrincipal.current}` }}>
                {valorDiariaPrincipal.current.toLocaleString("pt-br", {
                  minimumFractionDigits: 2,
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td style={{ color: `${color1fracao.current}` }}>
                1º Fração ({diferenca1.current} dias)
              </td>
              <td style={{ color: `${color1fracao.current}` }}>
                {valorDiariaFracao1.current.toLocaleString("pt-br", {
                  minimumFractionDigits: 2,
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
            <tr>
              <td style={{ color: `${color2fracao.current}` }}>
                2º Fração ({diferenca2.current} dias)
              </td>
              <td style={{ color: `${color2fracao.current}` }}>
                {valorDiariaFracao2.current.toLocaleString("pt-br", {
                  minimumFractionDigits: 2,
                  style: "currency",
                  currency: "BRL",
                })}
              </td>
            </tr>
          </table>
        </Flex>
      </Modal>
      {/* Modal referente as informações das frações */}
      {periodoSelecionado && (
        <Modal
        zIndex={20}
          open={modalFracionadosAberta}
          onCancel={() => {
            setModalFracionadosAberta(false);
            setPeriodoSelecionado(null);
          }}
          footer={null}
          title={`Período: ${periodoSelecionado.checkIn} até ${periodoSelecionado.checkOut}`}
        >
          <ContainerItems>
            <Items>
              <strong>Situação:</strong>{" "}
              <Icon>{periodoSelecionado.situacao || "—"}</Icon>
            </Items>

            {validateToken()?.nda != 0 && (
              <Items>
                <strong>Divulgado:</strong>{" "}
                <Icon>{periodoSelecionado.divulgado || "—"}</Icon>
              </Items>
            )}

            <Items>
              <strong>Valor Confirmado:</strong>{" "}
              <Icon>{formatValorReal(periodoSelecionado.valorMin) || "—"}</Icon>
            </Items>
            <Items>
              <strong>Valor Sugerido:</strong>{" "}
              <Icon>{formatValorReal(periodoSelecionado.valorSugerido) || "—"}</Icon>
            </Items>

            <Items
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <strong>Status:</strong>

              {periodoSelecionado.status === "DELEGADO" && (
                <>
                  <PersonOffIcon color="primary" />
                  <span style={{ fontSize: 12 }}>
                    Valores administrados pela Multicotas.
                  </span>
                </>
              )}

              {periodoSelecionado.status === "NAO_PERTUBE" && (
                <>
                  <DoDisturbOnIcon sx={{ color: red[900] }} />
                  <span style={{ fontSize: 12 }}>
                    Multicotas não sugerirá preço para esse período.
                  </span>
                </>
              )}

              {periodoSelecionado.status === "FINALIZADO" && (
                <>
                  <CheckCircleOutlineIcon color="success" />
                  <span style={{ fontSize: 12 }}>Período finalizado.</span>
                </>
              )}

              {periodoSelecionado.status === "VALOR_ALTO" && (
                <>
                  <ThumbDownIcon color="error" />
                  <span style={{ fontSize: 12 }}>Valor acima do sugerido.</span>
                </>
              )}

              {periodoSelecionado.status === "SEM_STATUS" &&
                periodoSelecionado.situacao !== "Não definido" && (
                  <>
                    <ThumbUpIcon color="success" />
                    <span style={{ fontSize: 12 }}>Tudo certo!</span>
                  </>
                )}

              {periodoSelecionado.situacao === "Não definido" && (
                <>
                  <HelpIcon color="warning" />
                  <span style={{ fontSize: 12 }}>
                    Defina um propósito para o período.
                  </span>
                </>
              )}

              {periodoSelecionado.status === "ALTERANDO" && (
                <>
                  <ChangeCircleIcon style={{ color: "red" }} />
                  <span style={{ fontSize: 12 }}>
                    Multicotas está atualizando. Aguarde.
                  </span>
                </>
              )}
            </Items>
          </ContainerItems>

          {/* Fracionados */}
          {periodoSelecionado.children?.length > 0 && (
            <ContainerFra style={{ marginTop: 15 }}>
              <strong>Períodos Fracionados:</strong>
              {periodoSelecionado.children.map((child: any, idx: number) => (
                <ItemsFra key={child.id} style={{
                      padding: '12px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      marginBottom: '10px',
                      backgroundColor: '#f9f9f9',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                    }}>
                   
                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <strong> {child.checkIn} a {child.checkOut}</strong>
                      </span>
                      
                      
                       
                            <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    showModalAcoes({
                      situacao: child.situacao,
                      divulgado: child.divulgado,
                      periodoUsuario: child.id,
                      periodo: child.periodoId,
                      valor: child.valorMin,
                      valorSugerido: child.valorSugerido,
                      fracionamento: child.fracionamento,
                      valorSugeridoSistema: child.valorSugeridoSistema,
                      statusAtual: child.status,
                      statusAnterior: child.statusAnterior,
                      dataSugestao: child.dataSugestao,
                      active: +child.active,
                      cotaUsuarioId: +child.idCTU,
                      specialDate: child.especial,
                      checkInPeriodo: child.checkIn,
                      alterando: child.alterado,
                      checkOutPeriodo: child.checkOut,
                    })
                  }
                  style={{
                    marginTop: 8,
                    backgroundColor: "#003644",
                    borderColor: "#003644",
                    color: "white",
                  }}
                    >
                      Ações
                            </Button>
                      </div>
                     

                
                      
                
                      <span>
                        <strong>Valor Confirmado:</strong> {formatValorReal(child.valorMin) || "—"}
                      </span>

                      <span>
                        <strong>Valor Sugerido:</strong> {formatValorReal(child.valorSugeridoSistema) || "—"}
                      </span>

                      <span>
                        <strong>Situação:</strong> {child.situacao || "—"}
                      </span>

                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <strong>Status:</strong>
                        {child.status === "DELEGADO" && (
                          <>
                            <PersonOffIcon color="primary" />
                            <span style={{ fontSize: 12 }}>Valores administrados pela Multicotas.</span>
                          </>
                        )}
                        {child.status === "NAO_PERTUBE" && (
                          <>
                            <DoDisturbOnIcon sx={{ color: red[900] }} />
                            <span style={{ fontSize: 12 }}>Multicotas não sugerirá preço para esse período.</span>
                          </>
                        )}
                        {child.status === "FINALIZADO" && (
                          <>
                            <CheckCircleOutlineIcon color="success" />
                            <span style={{ fontSize: 12 }}>Período finalizado.</span>
                          </>
                        )}
                        {child.status === "VALOR_ALTO" && (
                          <>
                            <ThumbDownIcon color="error" />
                            <span style={{ fontSize: 12 }}>Valor acima do sugerido.</span>
                          </>
                        )}
                        {child.status === "SEM_STATUS" && child.situacao !== "Não definido" && (
                          <>
                            <ThumbUpIcon color="success" />
                            <span style={{ fontSize: 12 }}>Tudo certo!</span>
                          </>
                        )}
                        {child.situacao === "Não definido" && (
                          <>
                            <HelpIcon color="warning" />
                            <span style={{ fontSize: 12 }}>Defina um propósito para o período.</span>
                          </>
                        )}
                        {child.status === "ALTERANDO" && (
                          <>
                            <ChangeCircleIcon style={{ color: "red" }} />
                            <span style={{ fontSize: 12 }}>Multicotas está atualizando. Aguarde.</span>
                          </>
                        )}
                      </span>

                      
                    </ItemsFra>

                // <ItemsFra key={child.id || idx}>
                //   <span>
                //     <strong>Check-in:</strong> {child.checkIn}
                //   </span>
                //   <span>
                //     <strong>Check-out:</strong> {child.checkOut}
                //   </span>
                //   <span>
                //     <strong>Valor Confirmado:</strong>{" "}
                //     {formatValorReal(child.valorMin) || "—"}
                //   </span>
                //   <span>
                //     <strong>Valor Sugerido:</strong>{" "}
                //     {formatValorReal(child.valorSugeridoSistema) || "—"}
                //   </span>
                //   <span>
                //     <strong>Situação:</strong> {child.situacao || "—"}
                //   </span>
                //   <span>
                //     <strong>Status:</strong>
                //     {/* 🔁 Copie aqui os mesmos blocos de status que você já usa */}
                //   </span>
                //   <Button
                //   type="primary"
                //   size="small"
                //   onClick={() =>
                //     showModalAcoes({
                //       situacao: child.situacao,
                //       divulgado: child.divulgado,
                //       periodoUsuario: child.id,
                //       periodo: child.periodoId,
                //       valor: child.valorMin,
                //       valorSugerido: child.valorSugerido,
                //       fracionamento: child.fracionamento,
                //       valorSugeridoSistema: child.valorSugeridoSistema,
                //       statusAtual: child.status,
                //       statusAnterior: child.statusAnterior,
                //       dataSugestao: child.dataSugestao,
                //       active: +child.active,
                //       cotaUsuarioId: +child.idCTU,
                //       specialDate: child.especial,
                //       checkInPeriodo: child.checkIn,
                //       alterando: child.alterado,
                //       checkOutPeriodo: child.checkOut,
                //     })
                //   }
                //   style={{
                //     marginTop: 8,
                //     backgroundColor: "#003644",
                //     borderColor: "#003644",
                //     color: "white",
                //   }}
                //     >
                //       Ações
                // </Button>

                // </ItemsFra>
              ))}
            </ContainerFra>
          )}
        </Modal>
)}


      <Modal
        title="Retirar delegação de período à Multicotas?"
        open={openRetirarDelegar}
        onOk={retirarDelegarPeriodos}
        onCancel={hideModalRetirarDelegar}
        okText="Sim, quero retirar"
        cancelText="Não"
      >
        <p>
          Com essa ação a Multicotas não mais decidirá por aplicações de
          desconto no seu período. Você será consultado caso haja alguma
          alteração de sugestão de preço. Caso não deseje receber as sugestões,
          clique em "Não pertube" no período em questão.
        </p>
      </Modal>
      <Modal
        title="Delegar período à Multicotas?"
        open={openDelegar}
        onOk={delegarPeriodos}
        onCancel={hideModalDelegar}
        okText="Sim, quero delegar"
        cancelText="Não"
      >
        <p>
          Essa ação delegará a Multicotas as decisões de aplicações de
          descontos, tanto no período principal como em suas frações. Os
          descontos tem limite de 30% do valor sugerido inicial do período
          (valor inicial - R$ {exibirMoeda(valorSugeridoInicial.current)}) e é
          aplicado gradualmente com a proximidade do check-in.
        </p>
      </Modal>
      <Modal
        title="Período divulgado, deseja continuar com a alteração?"
        open={openAlterandoDivulgado}
        onOk={alterarPeriodosDivulgados}
        onCancel={hideModalAlterarPeriodosDivulgados}
        okText="Sim, quero continuar"
        cancelText="Não"
      >
        <p>
          Esse período está sendo divulgado. As alterações realizadas não serão
          válidas até que a equipe responsável faça as devidas alterações nos
          anúncios correspondentes. Quando isso ocorrer, você receberá um e-mail
          notificando.
        </p>
      </Modal>
      <Modal
        title="Gostaria de voltar a receber as sugestões de preços desse período?"
        open={openRetirarNaoPertube}
        onOk={retirarNaoPertubePeriodos}
        onCancel={hideModalRetirarNaoPertube}
        okText="Sim, quero receber."
        cancelText="Não"
      >
        <p>
          Com essa ação, a Multicotas, provavelmente, voltará a enviar sugestões
          de preço a você.
        </p>
      </Modal>
      <Modal
        title="Gostaria de interromper as sugestões de preços desse período?"
        open={openNaoPertube}
        onOk={naoPertubePeriodos}
        onCancel={hideModalNaoPertube}
        okText="Sim, quero interromper."
        cancelText="Não"
      >
        <p>
          Com essa ação, a Multicotas não mais enviará sugestões de preço para
          esse período e suas frações.
        </p>
      </Modal>
      <Modal
        title="Tem certeza que deseja prosseguir?"
        open={openExcluirFracionados}
        onOk={excluirFracionadosAtualizando}
        onCancel={hideModalFracionados}
        okText="Sim, quero prosseguir"
        cancelText="Não"
      >
        <p>Os seus períodos fracionados poderão ser excluídos.</p>
      </Modal>

      <Modal
        title="Tem certeza que deseja excluir?"
        open={openExcluir}
        onOk={excluirPeriodo}
        onCancel={hideModal}
        okText="Sim, quero excluir"
        cancelText="Não"
      >
        <p>
          Essa ação não poderá ser desfeita. Será necessário criar outro
          período.
        </p>
      </Modal>
      <CollectionCreateFormValor
        open={openValor}
        onCreate={async function (valuesValor: ValuesValor): Promise<void> {
          onSubmitAtualizarValorAluguel(valuesValor);
        }}
        onCancel={function (): void {
          setOpenValor(false);
        }}
      />

      <Modal
        open={openModalPerguntaFracaoCompleta}
        title={
          titleFracaoCompleta
            ? "Deseja atualizar os fracionados também?"
            : "Deseja fracionar também?"
        }
        onOk={AbriModalFracaoCompleta}
        onCancel={FecharPerguntaFracaoCompleta}
        cancelText="Cancelar"
        okText="Sim"
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <Button onClick={AbrirModalValor}>Não</Button>
            <OkBtn />
          </>
        )}
      ></Modal>
      <CollectionCreateFormFracaoCompleta
        open={openFracaoCompleta}
        onCreate={async function (
          valuesFracaoCompleta: ValuesFracaoCompleta
        ): Promise<void> {
          onSubmitAtualizarValorAluguelFracaoCompleta(valuesFracaoCompleta);
        }}
        onCancel={function (): void {
          setOpenFracaoCompleta(false);
        }}
      />
      <CollectionCreateFormFracaoCompletaAtualizar
        open={openModalFracaoCompletaAtualizar}
        onCreate={async function (
          valuesFracaoCompletaAtualizar: ValuesFracaoCompletaAtualizar
        ): Promise<void> {
          onSubmitAtualizarValorAluguelFracaoCompleta(
            valuesFracaoCompletaAtualizar
          );
        }}
        onCancel={function (): void {
          atualizando.current = false;
          setOpenModalFracaoCompletaAtualizar(false);
        }}
      />
      <CollectionCreateFormMaisPeriodo
        open={openMaisPeriodo}
        onCreate={async function (
          valuesMaisPeriodo: ValuesMaisPeriodo
        ): Promise<void> {
          criarPeriodos(valuesMaisPeriodo);
        }}
        onCancel={function (): void {
          setOpenMaisPeriodo(false);
        }}
      />
      <ModalAcoes
        isModalOpen={isModalOpen}
        handleFechar={handleFechar}
        onClick={onClick}
        zIndex={1000}
        data={selectedData}
        selectedRowKeys={selectedRowKeys} // Substitua com o valor real
        emLote={emLote.current} // Substitua com o valor real
      />
     <FiltroMobileModal
        visible={modalFiltroAberto}
        onClose={() => setModalFiltroAberto(false)}
        onApply={aplicarFiltroMobile}
        filtros={{
          checkIn:
            filteredInfo?.checkIn?.[0] &&
            typeof filteredInfo.checkIn[0] === "string"
              ? dayjs(filteredInfo.checkIn[0])
              : null,
          checkOut:
            filteredInfo?.checkOut?.[0] &&
            typeof filteredInfo.checkOut[0] === "string"
              ? dayjs(filteredInfo.checkOut[0])
              : null,
          especial: filteredInfo?.especial?.[0] === true,
          situacao: Array.isArray(filteredInfo?.situacao)
            ? (filteredInfo.situacao as string[])
            : [],
          status: Array.isArray(filteredInfo?.status)
            ? (filteredInfo.status as string[])
            : [],
        }}
      />
      <ModalReserva
        isModalOpen={openModalReserva}
        handleFechar={handleFecharReseva}
        onCreate={handleCreate}
      />
    </>
  );
}
